//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param email (optional) 
     * @param userId (optional) 
     * @return Success
     */
    userNameOrEmailExist(email: string | undefined, userId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Account/UserNameOrEmailExist?";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserNameOrEmailExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserNameOrEmailExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUserNameOrEmailExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param token (optional) 
     * @return Success
     */
    confirmEmail(userId: number | undefined, token: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Account/ConfirmEmail?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processConfirmEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param password (optional) 
     * @param token (optional) 
     * @return Success
     */
    activateAccount(userId: number | undefined, password: string | undefined, token: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Account/ActivateAccount?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (password === null)
            throw new globalThis.Error("The parameter 'password' cannot be null.");
        else if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processActivateAccount(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    forgotPassword(body: ForgotPasswordDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Account/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processForgotPassword(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param token (optional) 
     * @return Success
     */
    sendNewPasswordAfterReset(userId: number | undefined, token: string | undefined): Observable<ResetPasswordResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendNewPasswordAfterReset?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendNewPasswordAfterReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendNewPasswordAfterReset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResetPasswordResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResetPasswordResultDto>;
        }));
    }

    protected processSendNewPasswordAfterReset(response: HttpResponseBase): Observable<ResetPasswordResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AssignedUserCustomerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param isPaginated (optional) 
     * @param keyword (optional) 
     * @param customerId (optional) 
     * @param userId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(isPaginated: boolean | undefined, keyword: string | undefined, customerId: number | undefined, userId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AssignedUserCustomerItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AssignedUserCustomer/GetAll?";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignedUserCustomerItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignedUserCustomerItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AssignedUserCustomerItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignedUserCustomerItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateAssignedUserCustomerDto | undefined): Observable<AssignedUserCustomerDto> {
        let url_ = this.baseUrl + "/api/services/app/AssignedUserCustomer/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignedUserCustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignedUserCustomerDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AssignedUserCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignedUserCustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPermissions(id: number | undefined): Observable<AssignedUserPermissionsDto> {
        let url_ = this.baseUrl + "/api/services/app/AssignedUserCustomer/GetPermissions?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignedUserPermissionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignedUserPermissionsDto>;
        }));
    }

    protected processGetPermissions(response: HttpResponseBase): Observable<AssignedUserPermissionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignedUserPermissionsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendReminderMail(body: SendReminderMailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AssignedUserCustomer/SendReminderMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendReminderMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendReminderMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendReminderMail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AssignedUserCustomer/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param customerId (optional) 
     * @return Success
     */
    getByCustomerId(customerId: number | undefined): Observable<AssignedUserCustomerDto> {
        let url_ = this.baseUrl + "/api/services/app/AssignedUserCustomer/GetByCustomerId?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCustomerId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCustomerId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignedUserCustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignedUserCustomerDto>;
        }));
    }

    protected processGetByCustomerId(response: HttpResponseBase): Observable<AssignedUserCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignedUserCustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateAssignedUserCustomerDto | undefined): Observable<AssignedUserCustomerDto> {
        let url_ = this.baseUrl + "/api/services/app/AssignedUserCustomer/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignedUserCustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignedUserCustomerDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AssignedUserCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignedUserCustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<AssignedUserCustomerDto> {
        let url_ = this.baseUrl + "/api/services/app/AssignedUserCustomer/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignedUserCustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignedUserCustomerDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AssignedUserCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignedUserCustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUiTheme(body: ChangeUiThemeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUiTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUiTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param token (optional) 
     * @return Success
     */
    changeGitToken(token: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeGitToken?";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeGitToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeGitToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeGitToken(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CustomerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param isPaginated (optional) 
     * @param userId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isPaginated: boolean | undefined, userId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomerItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CustomerItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CustomerDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Customer/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCustomerDto | undefined): Observable<CustomerDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCustomerDto | undefined): Observable<CustomerDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DocumentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param customerIds (optional) 
     * @param excludeAlreadyAssignedCustomer_Id (optional) 
     * @param paperworkIds (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, customerIds: number[] | undefined, excludeAlreadyAssignedCustomer_Id: number | undefined, paperworkIds: number[] | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<DocumentItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (customerIds === null)
            throw new globalThis.Error("The parameter 'customerIds' cannot be null.");
        else if (customerIds !== undefined)
            customerIds && customerIds.forEach(item => { url_ += "CustomerIds=" + encodeURIComponent("" + item) + "&"; });
        if (excludeAlreadyAssignedCustomer_Id === null)
            throw new globalThis.Error("The parameter 'excludeAlreadyAssignedCustomer_Id' cannot be null.");
        else if (excludeAlreadyAssignedCustomer_Id !== undefined)
            url_ += "ExcludeAlreadyAssignedCustomer.Id=" + encodeURIComponent("" + excludeAlreadyAssignedCustomer_Id) + "&";
        if (paperworkIds === null)
            throw new globalThis.Error("The parameter 'paperworkIds' cannot be null.");
        else if (paperworkIds !== undefined)
            paperworkIds && paperworkIds.forEach(item => { url_ += "PaperworkIds=" + encodeURIComponent("" + item) + "&"; });
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DocumentItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param documentId (optional) 
     * @return Success
     */
    getCustomersByDocumentId(documentId: number | undefined): Observable<CustomerDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/GetCustomersByDocumentId?";
        if (documentId === null)
            throw new globalThis.Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomersByDocumentId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomersByDocumentId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerDtoPagedResultDto>;
        }));
    }

    protected processGetCustomersByDocumentId(response: HttpResponseBase): Observable<CustomerDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    associate(body: AssociateDocumentInput | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/Associate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssociate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssociate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto>;
        }));
    }

    protected processAssociate(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    canBeDeleted(body: Int64EntityDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Document/CanBeDeleted";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanBeDeleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanBeDeleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCanBeDeleted(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Document/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateDocumentDto | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateDocumentDto | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DocumentCompilationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param paperworkIds (optional) 
     * @param isWithFiles (optional) 
     * @param customerId (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(paperworkIds: number[] | undefined, isWithFiles: boolean | undefined, customerId: number | undefined, sorting: string | undefined): Observable<DocumentCompilationItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentCompilation/GetAll?";
        if (paperworkIds === null)
            throw new globalThis.Error("The parameter 'paperworkIds' cannot be null.");
        else if (paperworkIds !== undefined)
            paperworkIds && paperworkIds.forEach(item => { url_ += "PaperworkIds=" + encodeURIComponent("" + item) + "&"; });
        if (isWithFiles === null)
            throw new globalThis.Error("The parameter 'isWithFiles' cannot be null.");
        else if (isWithFiles !== undefined)
            url_ += "IsWithFiles=" + encodeURIComponent("" + isWithFiles) + "&";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentCompilationItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentCompilationItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DocumentCompilationItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentCompilationItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentCompilation/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    checkPDFFilesCompatibility(fileId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CheckPDFFilesResultDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentCompilation/CheckPDFFilesCompatibility?";
        if (fileId === null)
            throw new globalThis.Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckPDFFilesCompatibility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckPDFFilesCompatibility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckPDFFilesResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckPDFFilesResultDto>;
        }));
    }

    protected processCheckPDFFilesCompatibility(response: HttpResponseBase): Observable<CheckPDFFilesResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckPDFFilesResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    startExportJob(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/DocumentCompilation/StartExportJob";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartExportJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartExportJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processStartExportJob(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    wizardExport(body: WizardInputDto | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentCompilation/WizardExport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWizardExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWizardExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processWizardExport(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param jobId (optional) 
     * @param isConcat (optional) 
     * @param hasMetadata (optional) 
     * @return Success
     */
    completeExportJob(jobId: string | undefined, isConcat: boolean | undefined, hasMetadata: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentCompilation/CompleteExportJob?";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        if (isConcat === null)
            throw new globalThis.Error("The parameter 'isConcat' cannot be null.");
        else if (isConcat !== undefined)
            url_ += "isConcat=" + encodeURIComponent("" + isConcat) + "&";
        if (hasMetadata === null)
            throw new globalThis.Error("The parameter 'hasMetadata' cannot be null.");
        else if (hasMetadata !== undefined)
            url_ += "hasMetadata=" + encodeURIComponent("" + hasMetadata) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteExportJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteExportJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompleteExportJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateDocumentCompilationDto | undefined): Observable<DocumentCompilationDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentCompilation/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentCompilationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentCompilationDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DocumentCompilationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentCompilationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateDocumentCompilationDto | undefined): Observable<DocumentCompilationDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentCompilation/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentCompilationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentCompilationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DocumentCompilationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentCompilationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<DocumentCompilationDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentCompilation/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentCompilationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentCompilationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DocumentCompilationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentCompilationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DocumentDynamicPropertyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateDocumentDynamicPropertyDto | undefined): Observable<DocumentDynamicPropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentDynamicProperty/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDynamicPropertyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDynamicPropertyDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DocumentDynamicPropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDynamicPropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateDocumentDynamicPropertyDto | undefined): Observable<DocumentDynamicPropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentDynamicProperty/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDynamicPropertyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDynamicPropertyDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DocumentDynamicPropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDynamicPropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentDynamicProperty/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<DocumentDynamicPropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentDynamicProperty/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDynamicPropertyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDynamicPropertyDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DocumentDynamicPropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDynamicPropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param documentIds (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(documentIds: number[] | undefined, sorting: string | undefined): Observable<DocumentDynamicPropertyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentDynamicProperty/GetAll?";
        if (documentIds === null)
            throw new globalThis.Error("The parameter 'documentIds' cannot be null.");
        else if (documentIds !== undefined)
            documentIds && documentIds.forEach(item => { url_ += "DocumentIds=" + encodeURIComponent("" + item) + "&"; });
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDynamicPropertyDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDynamicPropertyDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DocumentDynamicPropertyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDynamicPropertyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DocumentPaperworkTemplateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: DocumentPaperworkTemplateDto | undefined): Observable<DocumentPaperworkTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentPaperworkTemplate/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentPaperworkTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentPaperworkTemplateDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DocumentPaperworkTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentPaperworkTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateDocumentPaperworkTemplateDto | undefined): Observable<DocumentPaperworkTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentPaperworkTemplate/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentPaperworkTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentPaperworkTemplateDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DocumentPaperworkTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentPaperworkTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentPaperworkTemplate/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<DocumentPaperworkTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentPaperworkTemplate/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentPaperworkTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentPaperworkTemplateDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DocumentPaperworkTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentPaperworkTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keywork (optional) 
     * @param templateIds (optional) 
     * @param document_Id (optional) 
     * @param customerIds (optional) 
     * @return Success
     */
    getAll(keywork: string | undefined, templateIds: number[] | undefined, document_Id: number | undefined, customerIds: number[] | undefined): Observable<DocumentPaperworkTemplateItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentPaperworkTemplate/GetAll?";
        if (keywork === null)
            throw new globalThis.Error("The parameter 'keywork' cannot be null.");
        else if (keywork !== undefined)
            url_ += "Keywork=" + encodeURIComponent("" + keywork) + "&";
        if (templateIds === null)
            throw new globalThis.Error("The parameter 'templateIds' cannot be null.");
        else if (templateIds !== undefined)
            templateIds && templateIds.forEach(item => { url_ += "TemplateIds=" + encodeURIComponent("" + item) + "&"; });
        if (document_Id === null)
            throw new globalThis.Error("The parameter 'document_Id' cannot be null.");
        else if (document_Id !== undefined)
            url_ += "Document.Id=" + encodeURIComponent("" + document_Id) + "&";
        if (customerIds === null)
            throw new globalThis.Error("The parameter 'customerIds' cannot be null.");
        else if (customerIds !== undefined)
            customerIds && customerIds.forEach(item => { url_ += "CustomerIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentPaperworkTemplateItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentPaperworkTemplateItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DocumentPaperworkTemplateItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentPaperworkTemplateItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param file (optional) 
     * @param documentCompilationId (optional) 
     * @return Success
     */
    create(file: FileParameter | undefined, documentCompilationId: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/File/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (documentCompilationId === null || documentCompilationId === undefined)
            throw new globalThis.Error("The parameter 'documentCompilationId' cannot be null.");
        else
            content_.append("DocumentCompilationId", documentCompilationId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return Success
     */
    downloadFile(fileId: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/app/File/DownloadFile?";
        if (fileId === null)
            throw new globalThis.Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return Success
     */
    getFile(fileId: number | undefined): Observable<FileExtendedDto> {
        let url_ = this.baseUrl + "/api/services/app/File/GetFile?";
        if (fileId === null)
            throw new globalThis.Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExtendedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExtendedDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileExtendedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExtendedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/File/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/File/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param name (optional) 
     * @param extension (optional) 
     * @param mineType (optional) 
     * @param size (optional) 
     * @param documentCompilationId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(name: string | undefined, extension: string | undefined, mineType: string | undefined, size: number | undefined, documentCompilationId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/File/GetAll?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (extension === null)
            throw new globalThis.Error("The parameter 'extension' cannot be null.");
        else if (extension !== undefined)
            url_ += "Extension=" + encodeURIComponent("" + extension) + "&";
        if (mineType === null)
            throw new globalThis.Error("The parameter 'mineType' cannot be null.");
        else if (mineType !== undefined)
            url_ += "MineType=" + encodeURIComponent("" + mineType) + "&";
        if (size === null)
            throw new globalThis.Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        if (documentCompilationId === null)
            throw new globalThis.Error("The parameter 'documentCompilationId' cannot be null.");
        else if (documentCompilationId !== undefined)
            url_ += "DocumentCompilationId=" + encodeURIComponent("" + documentCompilationId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FileDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PaperworkServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param customer_Name (optional) 
     * @param customer_CustomerCode (optional) 
     * @param customer_AssignedUserCustomers (optional) 
     * @param customer_IsDeleted (optional) 
     * @param customer_DeleterUserId (optional) 
     * @param customer_DeletionTime (optional) 
     * @param customer_LastModificationTime (optional) 
     * @param customer_LastModifierUserId (optional) 
     * @param customer_CreationTime (optional) 
     * @param customer_CreatorUserId (optional) 
     * @param customer_Id (optional) 
     * @param customerIds (optional) 
     * @param stateIds (optional) 
     * @param documentIds (optional) 
     * @param content (optional) 
     * @param anomaly (optional) 
     * @param note (optional) 
     * @param template_Id (optional) 
     * @param fileName (optional) 
     * @param anomalyDescription (optional) 
     * @param templatePaperworkIds (optional) 
     * @param isWithFiles (optional) 
     * @param documentTypeIds (optional) 
     * @param dynamicFieldIds (optional) 
     * @param excludeExported (optional) 
     * @param exportedFromDate (optional) 
     * @param exportedToDate (optional) 
     * @param creationDateFrom (optional) 
     * @param creationDateTo (optional) 
     * @param modificationDateFrom (optional) 
     * @param modificationDateTo (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, customer_Name: string | undefined, customer_CustomerCode: string | undefined, customer_AssignedUserCustomers: AssignedUserCustomer[] | undefined, customer_IsDeleted: boolean | undefined, customer_DeleterUserId: number | undefined, customer_DeletionTime: moment.Moment | undefined, customer_LastModificationTime: moment.Moment | undefined, customer_LastModifierUserId: number | undefined, customer_CreationTime: moment.Moment | undefined, customer_CreatorUserId: number | undefined, customer_Id: number | undefined, customerIds: number[] | undefined, stateIds: number[] | undefined, documentIds: number[] | undefined, content: string | undefined, anomaly: boolean | undefined, note: string | undefined, template_Id: number | undefined, fileName: string | undefined, anomalyDescription: string | undefined, templatePaperworkIds: number[] | undefined, isWithFiles: boolean | undefined, documentTypeIds: number[] | undefined, dynamicFieldIds: number[] | undefined, excludeExported: boolean | undefined, exportedFromDate: moment.Moment | undefined, exportedToDate: moment.Moment | undefined, creationDateFrom: moment.Moment | undefined, creationDateTo: moment.Moment | undefined, modificationDateFrom: moment.Moment | undefined, modificationDateTo: moment.Moment | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PaperworkItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Paperwork/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (customer_Name === null)
            throw new globalThis.Error("The parameter 'customer_Name' cannot be null.");
        else if (customer_Name !== undefined)
            url_ += "Customer.Name=" + encodeURIComponent("" + customer_Name) + "&";
        if (customer_CustomerCode === null)
            throw new globalThis.Error("The parameter 'customer_CustomerCode' cannot be null.");
        else if (customer_CustomerCode !== undefined)
            url_ += "Customer.CustomerCode=" + encodeURIComponent("" + customer_CustomerCode) + "&";
        if (customer_AssignedUserCustomers === null)
            throw new globalThis.Error("The parameter 'customer_AssignedUserCustomers' cannot be null.");
        else if (customer_AssignedUserCustomers !== undefined)
            customer_AssignedUserCustomers && customer_AssignedUserCustomers.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Customer.AssignedUserCustomers[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (customer_IsDeleted === null)
            throw new globalThis.Error("The parameter 'customer_IsDeleted' cannot be null.");
        else if (customer_IsDeleted !== undefined)
            url_ += "Customer.IsDeleted=" + encodeURIComponent("" + customer_IsDeleted) + "&";
        if (customer_DeleterUserId === null)
            throw new globalThis.Error("The parameter 'customer_DeleterUserId' cannot be null.");
        else if (customer_DeleterUserId !== undefined)
            url_ += "Customer.DeleterUserId=" + encodeURIComponent("" + customer_DeleterUserId) + "&";
        if (customer_DeletionTime === null)
            throw new globalThis.Error("The parameter 'customer_DeletionTime' cannot be null.");
        else if (customer_DeletionTime !== undefined)
            url_ += "Customer.DeletionTime=" + encodeURIComponent(customer_DeletionTime ? "" + customer_DeletionTime.toISOString() : "") + "&";
        if (customer_LastModificationTime === null)
            throw new globalThis.Error("The parameter 'customer_LastModificationTime' cannot be null.");
        else if (customer_LastModificationTime !== undefined)
            url_ += "Customer.LastModificationTime=" + encodeURIComponent(customer_LastModificationTime ? "" + customer_LastModificationTime.toISOString() : "") + "&";
        if (customer_LastModifierUserId === null)
            throw new globalThis.Error("The parameter 'customer_LastModifierUserId' cannot be null.");
        else if (customer_LastModifierUserId !== undefined)
            url_ += "Customer.LastModifierUserId=" + encodeURIComponent("" + customer_LastModifierUserId) + "&";
        if (customer_CreationTime === null)
            throw new globalThis.Error("The parameter 'customer_CreationTime' cannot be null.");
        else if (customer_CreationTime !== undefined)
            url_ += "Customer.CreationTime=" + encodeURIComponent(customer_CreationTime ? "" + customer_CreationTime.toISOString() : "") + "&";
        if (customer_CreatorUserId === null)
            throw new globalThis.Error("The parameter 'customer_CreatorUserId' cannot be null.");
        else if (customer_CreatorUserId !== undefined)
            url_ += "Customer.CreatorUserId=" + encodeURIComponent("" + customer_CreatorUserId) + "&";
        if (customer_Id === null)
            throw new globalThis.Error("The parameter 'customer_Id' cannot be null.");
        else if (customer_Id !== undefined)
            url_ += "Customer.Id=" + encodeURIComponent("" + customer_Id) + "&";
        if (customerIds === null)
            throw new globalThis.Error("The parameter 'customerIds' cannot be null.");
        else if (customerIds !== undefined)
            customerIds && customerIds.forEach(item => { url_ += "CustomerIds=" + encodeURIComponent("" + item) + "&"; });
        if (stateIds === null)
            throw new globalThis.Error("The parameter 'stateIds' cannot be null.");
        else if (stateIds !== undefined)
            stateIds && stateIds.forEach(item => { url_ += "StateIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentIds === null)
            throw new globalThis.Error("The parameter 'documentIds' cannot be null.");
        else if (documentIds !== undefined)
            documentIds && documentIds.forEach(item => { url_ += "DocumentIds=" + encodeURIComponent("" + item) + "&"; });
        if (content === null)
            throw new globalThis.Error("The parameter 'content' cannot be null.");
        else if (content !== undefined)
            url_ += "Content=" + encodeURIComponent("" + content) + "&";
        if (anomaly === null)
            throw new globalThis.Error("The parameter 'anomaly' cannot be null.");
        else if (anomaly !== undefined)
            url_ += "Anomaly=" + encodeURIComponent("" + anomaly) + "&";
        if (note === null)
            throw new globalThis.Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "Note=" + encodeURIComponent("" + note) + "&";
        if (template_Id === null)
            throw new globalThis.Error("The parameter 'template_Id' cannot be null.");
        else if (template_Id !== undefined)
            url_ += "Template.Id=" + encodeURIComponent("" + template_Id) + "&";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        if (anomalyDescription === null)
            throw new globalThis.Error("The parameter 'anomalyDescription' cannot be null.");
        else if (anomalyDescription !== undefined)
            url_ += "AnomalyDescription=" + encodeURIComponent("" + anomalyDescription) + "&";
        if (templatePaperworkIds === null)
            throw new globalThis.Error("The parameter 'templatePaperworkIds' cannot be null.");
        else if (templatePaperworkIds !== undefined)
            templatePaperworkIds && templatePaperworkIds.forEach(item => { url_ += "TemplatePaperworkIds=" + encodeURIComponent("" + item) + "&"; });
        if (isWithFiles === null)
            throw new globalThis.Error("The parameter 'isWithFiles' cannot be null.");
        else if (isWithFiles !== undefined)
            url_ += "IsWithFiles=" + encodeURIComponent("" + isWithFiles) + "&";
        if (documentTypeIds === null)
            throw new globalThis.Error("The parameter 'documentTypeIds' cannot be null.");
        else if (documentTypeIds !== undefined)
            documentTypeIds && documentTypeIds.forEach(item => { url_ += "DocumentTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (dynamicFieldIds === null)
            throw new globalThis.Error("The parameter 'dynamicFieldIds' cannot be null.");
        else if (dynamicFieldIds !== undefined)
            dynamicFieldIds && dynamicFieldIds.forEach(item => { url_ += "DynamicFieldIds=" + encodeURIComponent("" + item) + "&"; });
        if (excludeExported === null)
            throw new globalThis.Error("The parameter 'excludeExported' cannot be null.");
        else if (excludeExported !== undefined)
            url_ += "ExcludeExported=" + encodeURIComponent("" + excludeExported) + "&";
        if (exportedFromDate === null)
            throw new globalThis.Error("The parameter 'exportedFromDate' cannot be null.");
        else if (exportedFromDate !== undefined)
            url_ += "ExportedFromDate=" + encodeURIComponent(exportedFromDate ? "" + exportedFromDate.toISOString() : "") + "&";
        if (exportedToDate === null)
            throw new globalThis.Error("The parameter 'exportedToDate' cannot be null.");
        else if (exportedToDate !== undefined)
            url_ += "ExportedToDate=" + encodeURIComponent(exportedToDate ? "" + exportedToDate.toISOString() : "") + "&";
        if (creationDateFrom === null)
            throw new globalThis.Error("The parameter 'creationDateFrom' cannot be null.");
        else if (creationDateFrom !== undefined)
            url_ += "CreationDateFrom=" + encodeURIComponent(creationDateFrom ? "" + creationDateFrom.toISOString() : "") + "&";
        if (creationDateTo === null)
            throw new globalThis.Error("The parameter 'creationDateTo' cannot be null.");
        else if (creationDateTo !== undefined)
            url_ += "CreationDateTo=" + encodeURIComponent(creationDateTo ? "" + creationDateTo.toISOString() : "") + "&";
        if (modificationDateFrom === null)
            throw new globalThis.Error("The parameter 'modificationDateFrom' cannot be null.");
        else if (modificationDateFrom !== undefined)
            url_ += "ModificationDateFrom=" + encodeURIComponent(modificationDateFrom ? "" + modificationDateFrom.toISOString() : "") + "&";
        if (modificationDateTo === null)
            throw new globalThis.Error("The parameter 'modificationDateTo' cannot be null.");
        else if (modificationDateTo !== undefined)
            url_ += "ModificationDateTo=" + encodeURIComponent(modificationDateTo ? "" + modificationDateTo.toISOString() : "") + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaperworkItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaperworkItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PaperworkItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaperworkItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param excludeIds (optional) 
     * @param keyword (optional) 
     * @param customer_Name (optional) 
     * @param customer_CustomerCode (optional) 
     * @param customer_AssignedUserCustomers (optional) 
     * @param customer_IsDeleted (optional) 
     * @param customer_DeleterUserId (optional) 
     * @param customer_DeletionTime (optional) 
     * @param customer_LastModificationTime (optional) 
     * @param customer_LastModifierUserId (optional) 
     * @param customer_CreationTime (optional) 
     * @param customer_CreatorUserId (optional) 
     * @param customer_Id (optional) 
     * @param customerIds (optional) 
     * @param stateIds (optional) 
     * @param documentIds (optional) 
     * @param content (optional) 
     * @param anomaly (optional) 
     * @param note (optional) 
     * @param template_Id (optional) 
     * @param fileName (optional) 
     * @param anomalyDescription (optional) 
     * @param templatePaperworkIds (optional) 
     * @param isWithFiles (optional) 
     * @param documentTypeIds (optional) 
     * @param dynamicFieldIds (optional) 
     * @param excludeExported (optional) 
     * @param exportedFromDate (optional) 
     * @param exportedToDate (optional) 
     * @param creationDateFrom (optional) 
     * @param creationDateTo (optional) 
     * @param modificationDateFrom (optional) 
     * @param modificationDateTo (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPaperworkIdsForExport(excludeIds: number[] | undefined, keyword: string | undefined, customer_Name: string | undefined, customer_CustomerCode: string | undefined, customer_AssignedUserCustomers: AssignedUserCustomer[] | undefined, customer_IsDeleted: boolean | undefined, customer_DeleterUserId: number | undefined, customer_DeletionTime: moment.Moment | undefined, customer_LastModificationTime: moment.Moment | undefined, customer_LastModifierUserId: number | undefined, customer_CreationTime: moment.Moment | undefined, customer_CreatorUserId: number | undefined, customer_Id: number | undefined, customerIds: number[] | undefined, stateIds: number[] | undefined, documentIds: number[] | undefined, content: string | undefined, anomaly: boolean | undefined, note: string | undefined, template_Id: number | undefined, fileName: string | undefined, anomalyDescription: string | undefined, templatePaperworkIds: number[] | undefined, isWithFiles: boolean | undefined, documentTypeIds: number[] | undefined, dynamicFieldIds: number[] | undefined, excludeExported: boolean | undefined, exportedFromDate: moment.Moment | undefined, exportedToDate: moment.Moment | undefined, creationDateFrom: moment.Moment | undefined, creationDateTo: moment.Moment | undefined, modificationDateFrom: moment.Moment | undefined, modificationDateTo: moment.Moment | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/Paperwork/GetAllPaperworkIdsForExport?";
        if (excludeIds === null)
            throw new globalThis.Error("The parameter 'excludeIds' cannot be null.");
        else if (excludeIds !== undefined)
            excludeIds && excludeIds.forEach(item => { url_ += "ExcludeIds=" + encodeURIComponent("" + item) + "&"; });
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (customer_Name === null)
            throw new globalThis.Error("The parameter 'customer_Name' cannot be null.");
        else if (customer_Name !== undefined)
            url_ += "Customer.Name=" + encodeURIComponent("" + customer_Name) + "&";
        if (customer_CustomerCode === null)
            throw new globalThis.Error("The parameter 'customer_CustomerCode' cannot be null.");
        else if (customer_CustomerCode !== undefined)
            url_ += "Customer.CustomerCode=" + encodeURIComponent("" + customer_CustomerCode) + "&";
        if (customer_AssignedUserCustomers === null)
            throw new globalThis.Error("The parameter 'customer_AssignedUserCustomers' cannot be null.");
        else if (customer_AssignedUserCustomers !== undefined)
            customer_AssignedUserCustomers && customer_AssignedUserCustomers.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Customer.AssignedUserCustomers[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (customer_IsDeleted === null)
            throw new globalThis.Error("The parameter 'customer_IsDeleted' cannot be null.");
        else if (customer_IsDeleted !== undefined)
            url_ += "Customer.IsDeleted=" + encodeURIComponent("" + customer_IsDeleted) + "&";
        if (customer_DeleterUserId === null)
            throw new globalThis.Error("The parameter 'customer_DeleterUserId' cannot be null.");
        else if (customer_DeleterUserId !== undefined)
            url_ += "Customer.DeleterUserId=" + encodeURIComponent("" + customer_DeleterUserId) + "&";
        if (customer_DeletionTime === null)
            throw new globalThis.Error("The parameter 'customer_DeletionTime' cannot be null.");
        else if (customer_DeletionTime !== undefined)
            url_ += "Customer.DeletionTime=" + encodeURIComponent(customer_DeletionTime ? "" + customer_DeletionTime.toISOString() : "") + "&";
        if (customer_LastModificationTime === null)
            throw new globalThis.Error("The parameter 'customer_LastModificationTime' cannot be null.");
        else if (customer_LastModificationTime !== undefined)
            url_ += "Customer.LastModificationTime=" + encodeURIComponent(customer_LastModificationTime ? "" + customer_LastModificationTime.toISOString() : "") + "&";
        if (customer_LastModifierUserId === null)
            throw new globalThis.Error("The parameter 'customer_LastModifierUserId' cannot be null.");
        else if (customer_LastModifierUserId !== undefined)
            url_ += "Customer.LastModifierUserId=" + encodeURIComponent("" + customer_LastModifierUserId) + "&";
        if (customer_CreationTime === null)
            throw new globalThis.Error("The parameter 'customer_CreationTime' cannot be null.");
        else if (customer_CreationTime !== undefined)
            url_ += "Customer.CreationTime=" + encodeURIComponent(customer_CreationTime ? "" + customer_CreationTime.toISOString() : "") + "&";
        if (customer_CreatorUserId === null)
            throw new globalThis.Error("The parameter 'customer_CreatorUserId' cannot be null.");
        else if (customer_CreatorUserId !== undefined)
            url_ += "Customer.CreatorUserId=" + encodeURIComponent("" + customer_CreatorUserId) + "&";
        if (customer_Id === null)
            throw new globalThis.Error("The parameter 'customer_Id' cannot be null.");
        else if (customer_Id !== undefined)
            url_ += "Customer.Id=" + encodeURIComponent("" + customer_Id) + "&";
        if (customerIds === null)
            throw new globalThis.Error("The parameter 'customerIds' cannot be null.");
        else if (customerIds !== undefined)
            customerIds && customerIds.forEach(item => { url_ += "CustomerIds=" + encodeURIComponent("" + item) + "&"; });
        if (stateIds === null)
            throw new globalThis.Error("The parameter 'stateIds' cannot be null.");
        else if (stateIds !== undefined)
            stateIds && stateIds.forEach(item => { url_ += "StateIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentIds === null)
            throw new globalThis.Error("The parameter 'documentIds' cannot be null.");
        else if (documentIds !== undefined)
            documentIds && documentIds.forEach(item => { url_ += "DocumentIds=" + encodeURIComponent("" + item) + "&"; });
        if (content === null)
            throw new globalThis.Error("The parameter 'content' cannot be null.");
        else if (content !== undefined)
            url_ += "Content=" + encodeURIComponent("" + content) + "&";
        if (anomaly === null)
            throw new globalThis.Error("The parameter 'anomaly' cannot be null.");
        else if (anomaly !== undefined)
            url_ += "Anomaly=" + encodeURIComponent("" + anomaly) + "&";
        if (note === null)
            throw new globalThis.Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "Note=" + encodeURIComponent("" + note) + "&";
        if (template_Id === null)
            throw new globalThis.Error("The parameter 'template_Id' cannot be null.");
        else if (template_Id !== undefined)
            url_ += "Template.Id=" + encodeURIComponent("" + template_Id) + "&";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        if (anomalyDescription === null)
            throw new globalThis.Error("The parameter 'anomalyDescription' cannot be null.");
        else if (anomalyDescription !== undefined)
            url_ += "AnomalyDescription=" + encodeURIComponent("" + anomalyDescription) + "&";
        if (templatePaperworkIds === null)
            throw new globalThis.Error("The parameter 'templatePaperworkIds' cannot be null.");
        else if (templatePaperworkIds !== undefined)
            templatePaperworkIds && templatePaperworkIds.forEach(item => { url_ += "TemplatePaperworkIds=" + encodeURIComponent("" + item) + "&"; });
        if (isWithFiles === null)
            throw new globalThis.Error("The parameter 'isWithFiles' cannot be null.");
        else if (isWithFiles !== undefined)
            url_ += "IsWithFiles=" + encodeURIComponent("" + isWithFiles) + "&";
        if (documentTypeIds === null)
            throw new globalThis.Error("The parameter 'documentTypeIds' cannot be null.");
        else if (documentTypeIds !== undefined)
            documentTypeIds && documentTypeIds.forEach(item => { url_ += "DocumentTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (dynamicFieldIds === null)
            throw new globalThis.Error("The parameter 'dynamicFieldIds' cannot be null.");
        else if (dynamicFieldIds !== undefined)
            dynamicFieldIds && dynamicFieldIds.forEach(item => { url_ += "DynamicFieldIds=" + encodeURIComponent("" + item) + "&"; });
        if (excludeExported === null)
            throw new globalThis.Error("The parameter 'excludeExported' cannot be null.");
        else if (excludeExported !== undefined)
            url_ += "ExcludeExported=" + encodeURIComponent("" + excludeExported) + "&";
        if (exportedFromDate === null)
            throw new globalThis.Error("The parameter 'exportedFromDate' cannot be null.");
        else if (exportedFromDate !== undefined)
            url_ += "ExportedFromDate=" + encodeURIComponent(exportedFromDate ? "" + exportedFromDate.toISOString() : "") + "&";
        if (exportedToDate === null)
            throw new globalThis.Error("The parameter 'exportedToDate' cannot be null.");
        else if (exportedToDate !== undefined)
            url_ += "ExportedToDate=" + encodeURIComponent(exportedToDate ? "" + exportedToDate.toISOString() : "") + "&";
        if (creationDateFrom === null)
            throw new globalThis.Error("The parameter 'creationDateFrom' cannot be null.");
        else if (creationDateFrom !== undefined)
            url_ += "CreationDateFrom=" + encodeURIComponent(creationDateFrom ? "" + creationDateFrom.toISOString() : "") + "&";
        if (creationDateTo === null)
            throw new globalThis.Error("The parameter 'creationDateTo' cannot be null.");
        else if (creationDateTo !== undefined)
            url_ += "CreationDateTo=" + encodeURIComponent(creationDateTo ? "" + creationDateTo.toISOString() : "") + "&";
        if (modificationDateFrom === null)
            throw new globalThis.Error("The parameter 'modificationDateFrom' cannot be null.");
        else if (modificationDateFrom !== undefined)
            url_ += "ModificationDateFrom=" + encodeURIComponent(modificationDateFrom ? "" + modificationDateFrom.toISOString() : "") + "&";
        if (modificationDateTo === null)
            throw new globalThis.Error("The parameter 'modificationDateTo' cannot be null.");
        else if (modificationDateTo !== undefined)
            url_ += "ModificationDateTo=" + encodeURIComponent(modificationDateTo ? "" + modificationDateTo.toISOString() : "") + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaperworkIdsForExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaperworkIdsForExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetAllPaperworkIdsForExport(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    duplicate(body: PaperworkDuplicateDto | undefined): Observable<PaperworkDto> {
        let url_ = this.baseUrl + "/api/services/app/Paperwork/Duplicate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaperworkDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaperworkDto>;
        }));
    }

    protected processDuplicate(response: HttpResponseBase): Observable<PaperworkDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaperworkDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    downloadZip(id: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/app/Paperwork/DownloadZip?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadZip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadZip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadZip(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param customer_Name (optional) 
     * @param customer_CustomerCode (optional) 
     * @param customer_AssignedUserCustomers (optional) 
     * @param customer_IsDeleted (optional) 
     * @param customer_DeleterUserId (optional) 
     * @param customer_DeletionTime (optional) 
     * @param customer_LastModificationTime (optional) 
     * @param customer_LastModifierUserId (optional) 
     * @param customer_CreationTime (optional) 
     * @param customer_CreatorUserId (optional) 
     * @param customer_Id (optional) 
     * @param customerIds (optional) 
     * @param stateIds (optional) 
     * @param documentIds (optional) 
     * @param content (optional) 
     * @param anomaly (optional) 
     * @param note (optional) 
     * @param template_Id (optional) 
     * @param fileName (optional) 
     * @param anomalyDescription (optional) 
     * @param templatePaperworkIds (optional) 
     * @param isWithFiles (optional) 
     * @param documentTypeIds (optional) 
     * @param dynamicFieldIds (optional) 
     * @param excludeExported (optional) 
     * @param exportedFromDate (optional) 
     * @param exportedToDate (optional) 
     * @param creationDateFrom (optional) 
     * @param creationDateTo (optional) 
     * @param modificationDateFrom (optional) 
     * @param modificationDateTo (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    downloadPaperworkExcel(keyword: string | undefined, customer_Name: string | undefined, customer_CustomerCode: string | undefined, customer_AssignedUserCustomers: AssignedUserCustomer[] | undefined, customer_IsDeleted: boolean | undefined, customer_DeleterUserId: number | undefined, customer_DeletionTime: moment.Moment | undefined, customer_LastModificationTime: moment.Moment | undefined, customer_LastModifierUserId: number | undefined, customer_CreationTime: moment.Moment | undefined, customer_CreatorUserId: number | undefined, customer_Id: number | undefined, customerIds: number[] | undefined, stateIds: number[] | undefined, documentIds: number[] | undefined, content: string | undefined, anomaly: boolean | undefined, note: string | undefined, template_Id: number | undefined, fileName: string | undefined, anomalyDescription: string | undefined, templatePaperworkIds: number[] | undefined, isWithFiles: boolean | undefined, documentTypeIds: number[] | undefined, dynamicFieldIds: number[] | undefined, excludeExported: boolean | undefined, exportedFromDate: moment.Moment | undefined, exportedToDate: moment.Moment | undefined, creationDateFrom: moment.Moment | undefined, creationDateTo: moment.Moment | undefined, modificationDateFrom: moment.Moment | undefined, modificationDateTo: moment.Moment | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileExcelDto> {
        let url_ = this.baseUrl + "/api/services/app/Paperwork/DownloadPaperworkExcel?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (customer_Name === null)
            throw new globalThis.Error("The parameter 'customer_Name' cannot be null.");
        else if (customer_Name !== undefined)
            url_ += "Customer.Name=" + encodeURIComponent("" + customer_Name) + "&";
        if (customer_CustomerCode === null)
            throw new globalThis.Error("The parameter 'customer_CustomerCode' cannot be null.");
        else if (customer_CustomerCode !== undefined)
            url_ += "Customer.CustomerCode=" + encodeURIComponent("" + customer_CustomerCode) + "&";
        if (customer_AssignedUserCustomers === null)
            throw new globalThis.Error("The parameter 'customer_AssignedUserCustomers' cannot be null.");
        else if (customer_AssignedUserCustomers !== undefined)
            customer_AssignedUserCustomers && customer_AssignedUserCustomers.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Customer.AssignedUserCustomers[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (customer_IsDeleted === null)
            throw new globalThis.Error("The parameter 'customer_IsDeleted' cannot be null.");
        else if (customer_IsDeleted !== undefined)
            url_ += "Customer.IsDeleted=" + encodeURIComponent("" + customer_IsDeleted) + "&";
        if (customer_DeleterUserId === null)
            throw new globalThis.Error("The parameter 'customer_DeleterUserId' cannot be null.");
        else if (customer_DeleterUserId !== undefined)
            url_ += "Customer.DeleterUserId=" + encodeURIComponent("" + customer_DeleterUserId) + "&";
        if (customer_DeletionTime === null)
            throw new globalThis.Error("The parameter 'customer_DeletionTime' cannot be null.");
        else if (customer_DeletionTime !== undefined)
            url_ += "Customer.DeletionTime=" + encodeURIComponent(customer_DeletionTime ? "" + customer_DeletionTime.toISOString() : "") + "&";
        if (customer_LastModificationTime === null)
            throw new globalThis.Error("The parameter 'customer_LastModificationTime' cannot be null.");
        else if (customer_LastModificationTime !== undefined)
            url_ += "Customer.LastModificationTime=" + encodeURIComponent(customer_LastModificationTime ? "" + customer_LastModificationTime.toISOString() : "") + "&";
        if (customer_LastModifierUserId === null)
            throw new globalThis.Error("The parameter 'customer_LastModifierUserId' cannot be null.");
        else if (customer_LastModifierUserId !== undefined)
            url_ += "Customer.LastModifierUserId=" + encodeURIComponent("" + customer_LastModifierUserId) + "&";
        if (customer_CreationTime === null)
            throw new globalThis.Error("The parameter 'customer_CreationTime' cannot be null.");
        else if (customer_CreationTime !== undefined)
            url_ += "Customer.CreationTime=" + encodeURIComponent(customer_CreationTime ? "" + customer_CreationTime.toISOString() : "") + "&";
        if (customer_CreatorUserId === null)
            throw new globalThis.Error("The parameter 'customer_CreatorUserId' cannot be null.");
        else if (customer_CreatorUserId !== undefined)
            url_ += "Customer.CreatorUserId=" + encodeURIComponent("" + customer_CreatorUserId) + "&";
        if (customer_Id === null)
            throw new globalThis.Error("The parameter 'customer_Id' cannot be null.");
        else if (customer_Id !== undefined)
            url_ += "Customer.Id=" + encodeURIComponent("" + customer_Id) + "&";
        if (customerIds === null)
            throw new globalThis.Error("The parameter 'customerIds' cannot be null.");
        else if (customerIds !== undefined)
            customerIds && customerIds.forEach(item => { url_ += "CustomerIds=" + encodeURIComponent("" + item) + "&"; });
        if (stateIds === null)
            throw new globalThis.Error("The parameter 'stateIds' cannot be null.");
        else if (stateIds !== undefined)
            stateIds && stateIds.forEach(item => { url_ += "StateIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentIds === null)
            throw new globalThis.Error("The parameter 'documentIds' cannot be null.");
        else if (documentIds !== undefined)
            documentIds && documentIds.forEach(item => { url_ += "DocumentIds=" + encodeURIComponent("" + item) + "&"; });
        if (content === null)
            throw new globalThis.Error("The parameter 'content' cannot be null.");
        else if (content !== undefined)
            url_ += "Content=" + encodeURIComponent("" + content) + "&";
        if (anomaly === null)
            throw new globalThis.Error("The parameter 'anomaly' cannot be null.");
        else if (anomaly !== undefined)
            url_ += "Anomaly=" + encodeURIComponent("" + anomaly) + "&";
        if (note === null)
            throw new globalThis.Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "Note=" + encodeURIComponent("" + note) + "&";
        if (template_Id === null)
            throw new globalThis.Error("The parameter 'template_Id' cannot be null.");
        else if (template_Id !== undefined)
            url_ += "Template.Id=" + encodeURIComponent("" + template_Id) + "&";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        if (anomalyDescription === null)
            throw new globalThis.Error("The parameter 'anomalyDescription' cannot be null.");
        else if (anomalyDescription !== undefined)
            url_ += "AnomalyDescription=" + encodeURIComponent("" + anomalyDescription) + "&";
        if (templatePaperworkIds === null)
            throw new globalThis.Error("The parameter 'templatePaperworkIds' cannot be null.");
        else if (templatePaperworkIds !== undefined)
            templatePaperworkIds && templatePaperworkIds.forEach(item => { url_ += "TemplatePaperworkIds=" + encodeURIComponent("" + item) + "&"; });
        if (isWithFiles === null)
            throw new globalThis.Error("The parameter 'isWithFiles' cannot be null.");
        else if (isWithFiles !== undefined)
            url_ += "IsWithFiles=" + encodeURIComponent("" + isWithFiles) + "&";
        if (documentTypeIds === null)
            throw new globalThis.Error("The parameter 'documentTypeIds' cannot be null.");
        else if (documentTypeIds !== undefined)
            documentTypeIds && documentTypeIds.forEach(item => { url_ += "DocumentTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (dynamicFieldIds === null)
            throw new globalThis.Error("The parameter 'dynamicFieldIds' cannot be null.");
        else if (dynamicFieldIds !== undefined)
            dynamicFieldIds && dynamicFieldIds.forEach(item => { url_ += "DynamicFieldIds=" + encodeURIComponent("" + item) + "&"; });
        if (excludeExported === null)
            throw new globalThis.Error("The parameter 'excludeExported' cannot be null.");
        else if (excludeExported !== undefined)
            url_ += "ExcludeExported=" + encodeURIComponent("" + excludeExported) + "&";
        if (exportedFromDate === null)
            throw new globalThis.Error("The parameter 'exportedFromDate' cannot be null.");
        else if (exportedFromDate !== undefined)
            url_ += "ExportedFromDate=" + encodeURIComponent(exportedFromDate ? "" + exportedFromDate.toISOString() : "") + "&";
        if (exportedToDate === null)
            throw new globalThis.Error("The parameter 'exportedToDate' cannot be null.");
        else if (exportedToDate !== undefined)
            url_ += "ExportedToDate=" + encodeURIComponent(exportedToDate ? "" + exportedToDate.toISOString() : "") + "&";
        if (creationDateFrom === null)
            throw new globalThis.Error("The parameter 'creationDateFrom' cannot be null.");
        else if (creationDateFrom !== undefined)
            url_ += "CreationDateFrom=" + encodeURIComponent(creationDateFrom ? "" + creationDateFrom.toISOString() : "") + "&";
        if (creationDateTo === null)
            throw new globalThis.Error("The parameter 'creationDateTo' cannot be null.");
        else if (creationDateTo !== undefined)
            url_ += "CreationDateTo=" + encodeURIComponent(creationDateTo ? "" + creationDateTo.toISOString() : "") + "&";
        if (modificationDateFrom === null)
            throw new globalThis.Error("The parameter 'modificationDateFrom' cannot be null.");
        else if (modificationDateFrom !== undefined)
            url_ += "ModificationDateFrom=" + encodeURIComponent(modificationDateFrom ? "" + modificationDateFrom.toISOString() : "") + "&";
        if (modificationDateTo === null)
            throw new globalThis.Error("The parameter 'modificationDateTo' cannot be null.");
        else if (modificationDateTo !== undefined)
            url_ += "ModificationDateTo=" + encodeURIComponent(modificationDateTo ? "" + modificationDateTo.toISOString() : "") + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPaperworkExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPaperworkExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExcelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExcelDto>;
        }));
    }

    protected processDownloadPaperworkExcel(response: HttpResponseBase): Observable<FileExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param template_Id (optional) 
     * @param customer_Id (optional) 
     * @param title (optional) 
     * @return Success
     */
    checkTitle(template_Id: number | undefined, customer_Id: number | undefined, title: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Paperwork/CheckTitle?";
        if (template_Id === null)
            throw new globalThis.Error("The parameter 'template_Id' cannot be null.");
        else if (template_Id !== undefined)
            url_ += "Template.Id=" + encodeURIComponent("" + template_Id) + "&";
        if (customer_Id === null)
            throw new globalThis.Error("The parameter 'customer_Id' cannot be null.");
        else if (customer_Id !== undefined)
            url_ += "Customer.Id=" + encodeURIComponent("" + customer_Id) + "&";
        if (title === null)
            throw new globalThis.Error("The parameter 'title' cannot be null.");
        else if (title !== undefined)
            url_ += "Title=" + encodeURIComponent("" + title) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckTitle(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param customer_Name (optional) 
     * @param customer_CustomerCode (optional) 
     * @param customer_AssignedUserCustomers (optional) 
     * @param customer_IsDeleted (optional) 
     * @param customer_DeleterUserId (optional) 
     * @param customer_DeletionTime (optional) 
     * @param customer_LastModificationTime (optional) 
     * @param customer_LastModifierUserId (optional) 
     * @param customer_CreationTime (optional) 
     * @param customer_CreatorUserId (optional) 
     * @param customer_Id (optional) 
     * @param customerIds (optional) 
     * @param stateIds (optional) 
     * @param documentIds (optional) 
     * @param content (optional) 
     * @param anomaly (optional) 
     * @param note (optional) 
     * @param template_Id (optional) 
     * @param fileName (optional) 
     * @param anomalyDescription (optional) 
     * @param templatePaperworkIds (optional) 
     * @param isWithFiles (optional) 
     * @param documentTypeIds (optional) 
     * @param dynamicFieldIds (optional) 
     * @param excludeExported (optional) 
     * @param exportedFromDate (optional) 
     * @param exportedToDate (optional) 
     * @param creationDateFrom (optional) 
     * @param creationDateTo (optional) 
     * @param modificationDateFrom (optional) 
     * @param modificationDateTo (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    downloadPaperworkDocumentExcel(keyword: string | undefined, customer_Name: string | undefined, customer_CustomerCode: string | undefined, customer_AssignedUserCustomers: AssignedUserCustomer[] | undefined, customer_IsDeleted: boolean | undefined, customer_DeleterUserId: number | undefined, customer_DeletionTime: moment.Moment | undefined, customer_LastModificationTime: moment.Moment | undefined, customer_LastModifierUserId: number | undefined, customer_CreationTime: moment.Moment | undefined, customer_CreatorUserId: number | undefined, customer_Id: number | undefined, customerIds: number[] | undefined, stateIds: number[] | undefined, documentIds: number[] | undefined, content: string | undefined, anomaly: boolean | undefined, note: string | undefined, template_Id: number | undefined, fileName: string | undefined, anomalyDescription: string | undefined, templatePaperworkIds: number[] | undefined, isWithFiles: boolean | undefined, documentTypeIds: number[] | undefined, dynamicFieldIds: number[] | undefined, excludeExported: boolean | undefined, exportedFromDate: moment.Moment | undefined, exportedToDate: moment.Moment | undefined, creationDateFrom: moment.Moment | undefined, creationDateTo: moment.Moment | undefined, modificationDateFrom: moment.Moment | undefined, modificationDateTo: moment.Moment | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileExcelDto> {
        let url_ = this.baseUrl + "/api/services/app/Paperwork/DownloadPaperworkDocumentExcel?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (customer_Name === null)
            throw new globalThis.Error("The parameter 'customer_Name' cannot be null.");
        else if (customer_Name !== undefined)
            url_ += "Customer.Name=" + encodeURIComponent("" + customer_Name) + "&";
        if (customer_CustomerCode === null)
            throw new globalThis.Error("The parameter 'customer_CustomerCode' cannot be null.");
        else if (customer_CustomerCode !== undefined)
            url_ += "Customer.CustomerCode=" + encodeURIComponent("" + customer_CustomerCode) + "&";
        if (customer_AssignedUserCustomers === null)
            throw new globalThis.Error("The parameter 'customer_AssignedUserCustomers' cannot be null.");
        else if (customer_AssignedUserCustomers !== undefined)
            customer_AssignedUserCustomers && customer_AssignedUserCustomers.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Customer.AssignedUserCustomers[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (customer_IsDeleted === null)
            throw new globalThis.Error("The parameter 'customer_IsDeleted' cannot be null.");
        else if (customer_IsDeleted !== undefined)
            url_ += "Customer.IsDeleted=" + encodeURIComponent("" + customer_IsDeleted) + "&";
        if (customer_DeleterUserId === null)
            throw new globalThis.Error("The parameter 'customer_DeleterUserId' cannot be null.");
        else if (customer_DeleterUserId !== undefined)
            url_ += "Customer.DeleterUserId=" + encodeURIComponent("" + customer_DeleterUserId) + "&";
        if (customer_DeletionTime === null)
            throw new globalThis.Error("The parameter 'customer_DeletionTime' cannot be null.");
        else if (customer_DeletionTime !== undefined)
            url_ += "Customer.DeletionTime=" + encodeURIComponent(customer_DeletionTime ? "" + customer_DeletionTime.toISOString() : "") + "&";
        if (customer_LastModificationTime === null)
            throw new globalThis.Error("The parameter 'customer_LastModificationTime' cannot be null.");
        else if (customer_LastModificationTime !== undefined)
            url_ += "Customer.LastModificationTime=" + encodeURIComponent(customer_LastModificationTime ? "" + customer_LastModificationTime.toISOString() : "") + "&";
        if (customer_LastModifierUserId === null)
            throw new globalThis.Error("The parameter 'customer_LastModifierUserId' cannot be null.");
        else if (customer_LastModifierUserId !== undefined)
            url_ += "Customer.LastModifierUserId=" + encodeURIComponent("" + customer_LastModifierUserId) + "&";
        if (customer_CreationTime === null)
            throw new globalThis.Error("The parameter 'customer_CreationTime' cannot be null.");
        else if (customer_CreationTime !== undefined)
            url_ += "Customer.CreationTime=" + encodeURIComponent(customer_CreationTime ? "" + customer_CreationTime.toISOString() : "") + "&";
        if (customer_CreatorUserId === null)
            throw new globalThis.Error("The parameter 'customer_CreatorUserId' cannot be null.");
        else if (customer_CreatorUserId !== undefined)
            url_ += "Customer.CreatorUserId=" + encodeURIComponent("" + customer_CreatorUserId) + "&";
        if (customer_Id === null)
            throw new globalThis.Error("The parameter 'customer_Id' cannot be null.");
        else if (customer_Id !== undefined)
            url_ += "Customer.Id=" + encodeURIComponent("" + customer_Id) + "&";
        if (customerIds === null)
            throw new globalThis.Error("The parameter 'customerIds' cannot be null.");
        else if (customerIds !== undefined)
            customerIds && customerIds.forEach(item => { url_ += "CustomerIds=" + encodeURIComponent("" + item) + "&"; });
        if (stateIds === null)
            throw new globalThis.Error("The parameter 'stateIds' cannot be null.");
        else if (stateIds !== undefined)
            stateIds && stateIds.forEach(item => { url_ += "StateIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentIds === null)
            throw new globalThis.Error("The parameter 'documentIds' cannot be null.");
        else if (documentIds !== undefined)
            documentIds && documentIds.forEach(item => { url_ += "DocumentIds=" + encodeURIComponent("" + item) + "&"; });
        if (content === null)
            throw new globalThis.Error("The parameter 'content' cannot be null.");
        else if (content !== undefined)
            url_ += "Content=" + encodeURIComponent("" + content) + "&";
        if (anomaly === null)
            throw new globalThis.Error("The parameter 'anomaly' cannot be null.");
        else if (anomaly !== undefined)
            url_ += "Anomaly=" + encodeURIComponent("" + anomaly) + "&";
        if (note === null)
            throw new globalThis.Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "Note=" + encodeURIComponent("" + note) + "&";
        if (template_Id === null)
            throw new globalThis.Error("The parameter 'template_Id' cannot be null.");
        else if (template_Id !== undefined)
            url_ += "Template.Id=" + encodeURIComponent("" + template_Id) + "&";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        if (anomalyDescription === null)
            throw new globalThis.Error("The parameter 'anomalyDescription' cannot be null.");
        else if (anomalyDescription !== undefined)
            url_ += "AnomalyDescription=" + encodeURIComponent("" + anomalyDescription) + "&";
        if (templatePaperworkIds === null)
            throw new globalThis.Error("The parameter 'templatePaperworkIds' cannot be null.");
        else if (templatePaperworkIds !== undefined)
            templatePaperworkIds && templatePaperworkIds.forEach(item => { url_ += "TemplatePaperworkIds=" + encodeURIComponent("" + item) + "&"; });
        if (isWithFiles === null)
            throw new globalThis.Error("The parameter 'isWithFiles' cannot be null.");
        else if (isWithFiles !== undefined)
            url_ += "IsWithFiles=" + encodeURIComponent("" + isWithFiles) + "&";
        if (documentTypeIds === null)
            throw new globalThis.Error("The parameter 'documentTypeIds' cannot be null.");
        else if (documentTypeIds !== undefined)
            documentTypeIds && documentTypeIds.forEach(item => { url_ += "DocumentTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (dynamicFieldIds === null)
            throw new globalThis.Error("The parameter 'dynamicFieldIds' cannot be null.");
        else if (dynamicFieldIds !== undefined)
            dynamicFieldIds && dynamicFieldIds.forEach(item => { url_ += "DynamicFieldIds=" + encodeURIComponent("" + item) + "&"; });
        if (excludeExported === null)
            throw new globalThis.Error("The parameter 'excludeExported' cannot be null.");
        else if (excludeExported !== undefined)
            url_ += "ExcludeExported=" + encodeURIComponent("" + excludeExported) + "&";
        if (exportedFromDate === null)
            throw new globalThis.Error("The parameter 'exportedFromDate' cannot be null.");
        else if (exportedFromDate !== undefined)
            url_ += "ExportedFromDate=" + encodeURIComponent(exportedFromDate ? "" + exportedFromDate.toISOString() : "") + "&";
        if (exportedToDate === null)
            throw new globalThis.Error("The parameter 'exportedToDate' cannot be null.");
        else if (exportedToDate !== undefined)
            url_ += "ExportedToDate=" + encodeURIComponent(exportedToDate ? "" + exportedToDate.toISOString() : "") + "&";
        if (creationDateFrom === null)
            throw new globalThis.Error("The parameter 'creationDateFrom' cannot be null.");
        else if (creationDateFrom !== undefined)
            url_ += "CreationDateFrom=" + encodeURIComponent(creationDateFrom ? "" + creationDateFrom.toISOString() : "") + "&";
        if (creationDateTo === null)
            throw new globalThis.Error("The parameter 'creationDateTo' cannot be null.");
        else if (creationDateTo !== undefined)
            url_ += "CreationDateTo=" + encodeURIComponent(creationDateTo ? "" + creationDateTo.toISOString() : "") + "&";
        if (modificationDateFrom === null)
            throw new globalThis.Error("The parameter 'modificationDateFrom' cannot be null.");
        else if (modificationDateFrom !== undefined)
            url_ += "ModificationDateFrom=" + encodeURIComponent(modificationDateFrom ? "" + modificationDateFrom.toISOString() : "") + "&";
        if (modificationDateTo === null)
            throw new globalThis.Error("The parameter 'modificationDateTo' cannot be null.");
        else if (modificationDateTo !== undefined)
            url_ += "ModificationDateTo=" + encodeURIComponent(modificationDateTo ? "" + modificationDateTo.toISOString() : "") + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPaperworkDocumentExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPaperworkDocumentExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExcelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExcelDto>;
        }));
    }

    protected processDownloadPaperworkDocumentExcel(response: HttpResponseBase): Observable<FileExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param customer_Name (optional) 
     * @param customer_CustomerCode (optional) 
     * @param customer_AssignedUserCustomers (optional) 
     * @param customer_IsDeleted (optional) 
     * @param customer_DeleterUserId (optional) 
     * @param customer_DeletionTime (optional) 
     * @param customer_LastModificationTime (optional) 
     * @param customer_LastModifierUserId (optional) 
     * @param customer_CreationTime (optional) 
     * @param customer_CreatorUserId (optional) 
     * @param customer_Id (optional) 
     * @param customerIds (optional) 
     * @param stateIds (optional) 
     * @param documentIds (optional) 
     * @param content (optional) 
     * @param anomaly (optional) 
     * @param note (optional) 
     * @param template_Id (optional) 
     * @param fileName (optional) 
     * @param anomalyDescription (optional) 
     * @param templatePaperworkIds (optional) 
     * @param isWithFiles (optional) 
     * @param documentTypeIds (optional) 
     * @param dynamicFieldIds (optional) 
     * @param excludeExported (optional) 
     * @param exportedFromDate (optional) 
     * @param exportedToDate (optional) 
     * @param creationDateFrom (optional) 
     * @param creationDateTo (optional) 
     * @param modificationDateFrom (optional) 
     * @param modificationDateTo (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    downloadPaperworkDocumentCSV(keyword: string | undefined, customer_Name: string | undefined, customer_CustomerCode: string | undefined, customer_AssignedUserCustomers: AssignedUserCustomer[] | undefined, customer_IsDeleted: boolean | undefined, customer_DeleterUserId: number | undefined, customer_DeletionTime: moment.Moment | undefined, customer_LastModificationTime: moment.Moment | undefined, customer_LastModifierUserId: number | undefined, customer_CreationTime: moment.Moment | undefined, customer_CreatorUserId: number | undefined, customer_Id: number | undefined, customerIds: number[] | undefined, stateIds: number[] | undefined, documentIds: number[] | undefined, content: string | undefined, anomaly: boolean | undefined, note: string | undefined, template_Id: number | undefined, fileName: string | undefined, anomalyDescription: string | undefined, templatePaperworkIds: number[] | undefined, isWithFiles: boolean | undefined, documentTypeIds: number[] | undefined, dynamicFieldIds: number[] | undefined, excludeExported: boolean | undefined, exportedFromDate: moment.Moment | undefined, exportedToDate: moment.Moment | undefined, creationDateFrom: moment.Moment | undefined, creationDateTo: moment.Moment | undefined, modificationDateFrom: moment.Moment | undefined, modificationDateTo: moment.Moment | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileExcelDto> {
        let url_ = this.baseUrl + "/api/services/app/Paperwork/DownloadPaperworkDocumentCSV?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (customer_Name === null)
            throw new globalThis.Error("The parameter 'customer_Name' cannot be null.");
        else if (customer_Name !== undefined)
            url_ += "Customer.Name=" + encodeURIComponent("" + customer_Name) + "&";
        if (customer_CustomerCode === null)
            throw new globalThis.Error("The parameter 'customer_CustomerCode' cannot be null.");
        else if (customer_CustomerCode !== undefined)
            url_ += "Customer.CustomerCode=" + encodeURIComponent("" + customer_CustomerCode) + "&";
        if (customer_AssignedUserCustomers === null)
            throw new globalThis.Error("The parameter 'customer_AssignedUserCustomers' cannot be null.");
        else if (customer_AssignedUserCustomers !== undefined)
            customer_AssignedUserCustomers && customer_AssignedUserCustomers.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Customer.AssignedUserCustomers[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (customer_IsDeleted === null)
            throw new globalThis.Error("The parameter 'customer_IsDeleted' cannot be null.");
        else if (customer_IsDeleted !== undefined)
            url_ += "Customer.IsDeleted=" + encodeURIComponent("" + customer_IsDeleted) + "&";
        if (customer_DeleterUserId === null)
            throw new globalThis.Error("The parameter 'customer_DeleterUserId' cannot be null.");
        else if (customer_DeleterUserId !== undefined)
            url_ += "Customer.DeleterUserId=" + encodeURIComponent("" + customer_DeleterUserId) + "&";
        if (customer_DeletionTime === null)
            throw new globalThis.Error("The parameter 'customer_DeletionTime' cannot be null.");
        else if (customer_DeletionTime !== undefined)
            url_ += "Customer.DeletionTime=" + encodeURIComponent(customer_DeletionTime ? "" + customer_DeletionTime.toISOString() : "") + "&";
        if (customer_LastModificationTime === null)
            throw new globalThis.Error("The parameter 'customer_LastModificationTime' cannot be null.");
        else if (customer_LastModificationTime !== undefined)
            url_ += "Customer.LastModificationTime=" + encodeURIComponent(customer_LastModificationTime ? "" + customer_LastModificationTime.toISOString() : "") + "&";
        if (customer_LastModifierUserId === null)
            throw new globalThis.Error("The parameter 'customer_LastModifierUserId' cannot be null.");
        else if (customer_LastModifierUserId !== undefined)
            url_ += "Customer.LastModifierUserId=" + encodeURIComponent("" + customer_LastModifierUserId) + "&";
        if (customer_CreationTime === null)
            throw new globalThis.Error("The parameter 'customer_CreationTime' cannot be null.");
        else if (customer_CreationTime !== undefined)
            url_ += "Customer.CreationTime=" + encodeURIComponent(customer_CreationTime ? "" + customer_CreationTime.toISOString() : "") + "&";
        if (customer_CreatorUserId === null)
            throw new globalThis.Error("The parameter 'customer_CreatorUserId' cannot be null.");
        else if (customer_CreatorUserId !== undefined)
            url_ += "Customer.CreatorUserId=" + encodeURIComponent("" + customer_CreatorUserId) + "&";
        if (customer_Id === null)
            throw new globalThis.Error("The parameter 'customer_Id' cannot be null.");
        else if (customer_Id !== undefined)
            url_ += "Customer.Id=" + encodeURIComponent("" + customer_Id) + "&";
        if (customerIds === null)
            throw new globalThis.Error("The parameter 'customerIds' cannot be null.");
        else if (customerIds !== undefined)
            customerIds && customerIds.forEach(item => { url_ += "CustomerIds=" + encodeURIComponent("" + item) + "&"; });
        if (stateIds === null)
            throw new globalThis.Error("The parameter 'stateIds' cannot be null.");
        else if (stateIds !== undefined)
            stateIds && stateIds.forEach(item => { url_ += "StateIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentIds === null)
            throw new globalThis.Error("The parameter 'documentIds' cannot be null.");
        else if (documentIds !== undefined)
            documentIds && documentIds.forEach(item => { url_ += "DocumentIds=" + encodeURIComponent("" + item) + "&"; });
        if (content === null)
            throw new globalThis.Error("The parameter 'content' cannot be null.");
        else if (content !== undefined)
            url_ += "Content=" + encodeURIComponent("" + content) + "&";
        if (anomaly === null)
            throw new globalThis.Error("The parameter 'anomaly' cannot be null.");
        else if (anomaly !== undefined)
            url_ += "Anomaly=" + encodeURIComponent("" + anomaly) + "&";
        if (note === null)
            throw new globalThis.Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "Note=" + encodeURIComponent("" + note) + "&";
        if (template_Id === null)
            throw new globalThis.Error("The parameter 'template_Id' cannot be null.");
        else if (template_Id !== undefined)
            url_ += "Template.Id=" + encodeURIComponent("" + template_Id) + "&";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        if (anomalyDescription === null)
            throw new globalThis.Error("The parameter 'anomalyDescription' cannot be null.");
        else if (anomalyDescription !== undefined)
            url_ += "AnomalyDescription=" + encodeURIComponent("" + anomalyDescription) + "&";
        if (templatePaperworkIds === null)
            throw new globalThis.Error("The parameter 'templatePaperworkIds' cannot be null.");
        else if (templatePaperworkIds !== undefined)
            templatePaperworkIds && templatePaperworkIds.forEach(item => { url_ += "TemplatePaperworkIds=" + encodeURIComponent("" + item) + "&"; });
        if (isWithFiles === null)
            throw new globalThis.Error("The parameter 'isWithFiles' cannot be null.");
        else if (isWithFiles !== undefined)
            url_ += "IsWithFiles=" + encodeURIComponent("" + isWithFiles) + "&";
        if (documentTypeIds === null)
            throw new globalThis.Error("The parameter 'documentTypeIds' cannot be null.");
        else if (documentTypeIds !== undefined)
            documentTypeIds && documentTypeIds.forEach(item => { url_ += "DocumentTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (dynamicFieldIds === null)
            throw new globalThis.Error("The parameter 'dynamicFieldIds' cannot be null.");
        else if (dynamicFieldIds !== undefined)
            dynamicFieldIds && dynamicFieldIds.forEach(item => { url_ += "DynamicFieldIds=" + encodeURIComponent("" + item) + "&"; });
        if (excludeExported === null)
            throw new globalThis.Error("The parameter 'excludeExported' cannot be null.");
        else if (excludeExported !== undefined)
            url_ += "ExcludeExported=" + encodeURIComponent("" + excludeExported) + "&";
        if (exportedFromDate === null)
            throw new globalThis.Error("The parameter 'exportedFromDate' cannot be null.");
        else if (exportedFromDate !== undefined)
            url_ += "ExportedFromDate=" + encodeURIComponent(exportedFromDate ? "" + exportedFromDate.toISOString() : "") + "&";
        if (exportedToDate === null)
            throw new globalThis.Error("The parameter 'exportedToDate' cannot be null.");
        else if (exportedToDate !== undefined)
            url_ += "ExportedToDate=" + encodeURIComponent(exportedToDate ? "" + exportedToDate.toISOString() : "") + "&";
        if (creationDateFrom === null)
            throw new globalThis.Error("The parameter 'creationDateFrom' cannot be null.");
        else if (creationDateFrom !== undefined)
            url_ += "CreationDateFrom=" + encodeURIComponent(creationDateFrom ? "" + creationDateFrom.toISOString() : "") + "&";
        if (creationDateTo === null)
            throw new globalThis.Error("The parameter 'creationDateTo' cannot be null.");
        else if (creationDateTo !== undefined)
            url_ += "CreationDateTo=" + encodeURIComponent(creationDateTo ? "" + creationDateTo.toISOString() : "") + "&";
        if (modificationDateFrom === null)
            throw new globalThis.Error("The parameter 'modificationDateFrom' cannot be null.");
        else if (modificationDateFrom !== undefined)
            url_ += "ModificationDateFrom=" + encodeURIComponent(modificationDateFrom ? "" + modificationDateFrom.toISOString() : "") + "&";
        if (modificationDateTo === null)
            throw new globalThis.Error("The parameter 'modificationDateTo' cannot be null.");
        else if (modificationDateTo !== undefined)
            url_ += "ModificationDateTo=" + encodeURIComponent(modificationDateTo ? "" + modificationDateTo.toISOString() : "") + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPaperworkDocumentCSV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPaperworkDocumentCSV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExcelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExcelDto>;
        }));
    }

    protected processDownloadPaperworkDocumentCSV(response: HttpResponseBase): Observable<FileExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param customerId (optional) 
     * @param templateName (optional) 
     * @param file (optional) 
     * @return Success
     */
    importPaperworksFromCsv(customerId: number | undefined, templateName: string | undefined, file: FileParameter | undefined): Observable<ImportResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Paperwork/ImportPaperworksFromCsv?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (templateName === null)
            throw new globalThis.Error("The parameter 'templateName' cannot be null.");
        else if (templateName !== undefined)
            url_ += "templateName=" + encodeURIComponent("" + templateName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportPaperworksFromCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportPaperworksFromCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportResultDto>;
        }));
    }

    protected processImportPaperworksFromCsv(response: HttpResponseBase): Observable<ImportResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    exportPaperworkCsvTemplate(): Observable<FileExcelDto> {
        let url_ = this.baseUrl + "/api/services/app/Paperwork/ExportPaperworkCsvTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPaperworkCsvTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPaperworkCsvTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExcelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExcelDto>;
        }));
    }

    protected processExportPaperworkCsvTemplate(response: HttpResponseBase): Observable<FileExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePaperworkDto | undefined): Observable<PaperworkDto> {
        let url_ = this.baseUrl + "/api/services/app/Paperwork/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaperworkDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaperworkDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PaperworkDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaperworkDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePaperworkDto | undefined): Observable<PaperworkDto> {
        let url_ = this.baseUrl + "/api/services/app/Paperwork/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaperworkDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaperworkDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PaperworkDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaperworkDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PaperworkDto> {
        let url_ = this.baseUrl + "/api/services/app/Paperwork/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaperworkDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaperworkDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PaperworkDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaperworkDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param currentPaperworkId (optional) 
     * @return Success
     */
    getAvailableParents(currentPaperworkId: number | undefined): Observable<PaperworkParentDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Paperwork/GetAvailableParents?";
        if (currentPaperworkId === null)
            throw new globalThis.Error("The parameter 'currentPaperworkId' cannot be null.");
        else if (currentPaperworkId !== undefined)
            url_ += "currentPaperworkId=" + encodeURIComponent("" + currentPaperworkId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableParents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableParents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaperworkParentDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaperworkParentDtoListResultDto>;
        }));
    }

    protected processGetAvailableParents(response: HttpResponseBase): Observable<PaperworkParentDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaperworkParentDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Paperwork/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PaperworkLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportPaperworkLogCsv(body: PaperworkLogGetAllInput | undefined): Observable<FileExcelDto> {
        let url_ = this.baseUrl + "/api/services/app/PaperworkLog/ExportPaperworkLogCsv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPaperworkLogCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPaperworkLogCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExcelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExcelDto>;
        }));
    }

    protected processExportPaperworkLogCsv(response: HttpResponseBase): Observable<FileExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paperworkId (optional) 
     * @return Success
     */
    getLogsForPaperwork(paperworkId: number | undefined): Observable<PaperworkLogDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PaperworkLog/GetLogsForPaperwork?";
        if (paperworkId === null)
            throw new globalThis.Error("The parameter 'paperworkId' cannot be null.");
        else if (paperworkId !== undefined)
            url_ += "paperworkId=" + encodeURIComponent("" + paperworkId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLogsForPaperwork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogsForPaperwork(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaperworkLogDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaperworkLogDto[]>;
        }));
    }

    protected processGetLogsForPaperwork(response: HttpResponseBase): Observable<PaperworkLogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaperworkLogDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PaperworkLogDto> {
        let url_ = this.baseUrl + "/api/services/app/PaperworkLog/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaperworkLogDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaperworkLogDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PaperworkLogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaperworkLogDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paperworkId (optional) 
     * @param keyword (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param typeLogIds (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(paperworkId: number | undefined, keyword: string | undefined, fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, typeLogIds: number[] | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PaperworkLogItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PaperworkLog/GetAll?";
        if (paperworkId === null)
            throw new globalThis.Error("The parameter 'paperworkId' cannot be null.");
        else if (paperworkId !== undefined)
            url_ += "PaperworkId=" + encodeURIComponent("" + paperworkId) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (typeLogIds === null)
            throw new globalThis.Error("The parameter 'typeLogIds' cannot be null.");
        else if (typeLogIds !== undefined)
            typeLogIds && typeLogIds.forEach(item => { url_ += "TypeLogIds=" + encodeURIComponent("" + item) + "&"; });
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaperworkLogItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaperworkLogItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PaperworkLogItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaperworkLogItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PaperworkStateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param customerIds (optional) 
     * @param isPaged (optional) 
     * @param keyword (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(customerIds: number[] | undefined, isPaged: boolean | undefined, keyword: string | undefined, maxResultCount: number | undefined): Observable<PaperworkStateDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PaperworkState/GetAll?";
        if (customerIds === null)
            throw new globalThis.Error("The parameter 'customerIds' cannot be null.");
        else if (customerIds !== undefined)
            customerIds && customerIds.forEach(item => { url_ += "CustomerIds=" + encodeURIComponent("" + item) + "&"; });
        if (isPaged === null)
            throw new globalThis.Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaperworkStateDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaperworkStateDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PaperworkStateDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaperworkStateDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PaperworkTemplateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param customerIds (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(customerIds: number[] | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PaperworkTemplateItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PaperworkTemplate/GetAll?";
        if (customerIds === null)
            throw new globalThis.Error("The parameter 'customerIds' cannot be null.");
        else if (customerIds !== undefined)
            customerIds && customerIds.forEach(item => { url_ += "CustomerIds=" + encodeURIComponent("" + item) + "&"; });
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaperworkTemplateItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaperworkTemplateItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PaperworkTemplateItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaperworkTemplateItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaperworkTemplate/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePaperworkTemplateDto | undefined): Observable<PaperworkTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/PaperworkTemplate/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaperworkTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaperworkTemplateDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PaperworkTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaperworkTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePaperworkTemplateDto | undefined): Observable<PaperworkTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/PaperworkTemplate/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaperworkTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaperworkTemplateDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PaperworkTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaperworkTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PaperworkTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/PaperworkTemplate/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaperworkTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaperworkTemplateDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PaperworkTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaperworkTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getRoles(permission: string | undefined): Observable<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission === null)
            throw new globalThis.Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleListDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleListDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleListDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleListDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<PermissionDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionDtoListResultDto>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<PermissionDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RoleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new globalThis.Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TenantDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TypeLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param maxResultCount (optional) 
     * @param keyword (optional) 
     * @return Success
     */
    getAll(maxResultCount: number | undefined, keyword: string | undefined): Observable<DictionaryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TypeLog/GetAll?";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DictionaryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDev(body: CreateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateDev";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDev(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDev(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processCreateDev(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isPaginated (optional) 
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param customer (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(isPaginated: boolean | undefined, keyword: string | undefined, isActive: boolean | undefined, customer: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new globalThis.Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (customer === null)
            throw new globalThis.Error("The parameter 'customer' cannot be null.");
        else if (customer !== undefined)
            url_ += "Customer=" + encodeURIComponent("" + customer) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    toggleActivationUser(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ToggleActivationUser?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleActivationUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleActivationUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processToggleActivationUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    unlockLogin(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UnlockLogin?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlockLogin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    forceResetPassword(body: ForceResetPasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ForceResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForceResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForceResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processForceResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class Anomaly implements IAnomaly {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    description!: string | undefined;

    constructor(data?: IAnomaly) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): Anomaly {
        data = typeof data === 'object' ? data : {};
        let result = new Anomaly();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["description"] = this.description;
        return data;
    }

    clone(): Anomaly {
        const json = this.toJSON();
        let result = new Anomaly();
        result.init(json);
        return result;
    }
}

export interface IAnomaly {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    description: string | undefined;
}

export class AnomalyDto implements IAnomalyDto {
    id!: number;
    description!: string | undefined;

    constructor(data?: IAnomalyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): AnomalyDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnomalyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }

    clone(): AnomalyDto {
        const json = this.toJSON();
        let result = new AnomalyDto();
        result.init(json);
        return result;
    }
}

export interface IAnomalyDto {
    id: number;
    description: string | undefined;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version!: string | undefined;
    releaseDate!: moment.Moment;
    features!: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : undefined as any;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (this.features as any)![key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : undefined as any;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (data["features"] as any)[key] = (this.features as any)[key];
            }
        }
        return data;
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;
}

export class AssignedUserCustomer implements IAssignedUserCustomer {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    user!: User;
    customer!: Customer;
    canViewListPractice!: boolean;
    canCreatePractice!: boolean;
    canEditPractice!: boolean;
    canDeletePractice!: boolean;
    canViewListTemplate!: boolean;
    canCreateTemplate!: boolean;
    canEditTemplate!: boolean;
    canDeleteTemplate!: boolean;
    canViewListDocument!: boolean;
    canCreateDocument!: boolean;
    canEditDocument!: boolean;
    canDeleteDocument!: boolean;
    documentCompilation!: boolean;
    canExport!: boolean;

    constructor(data?: IAssignedUserCustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : undefined as any;
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : undefined as any;
            this.canViewListPractice = _data["canViewListPractice"];
            this.canCreatePractice = _data["canCreatePractice"];
            this.canEditPractice = _data["canEditPractice"];
            this.canDeletePractice = _data["canDeletePractice"];
            this.canViewListTemplate = _data["canViewListTemplate"];
            this.canCreateTemplate = _data["canCreateTemplate"];
            this.canEditTemplate = _data["canEditTemplate"];
            this.canDeleteTemplate = _data["canDeleteTemplate"];
            this.canViewListDocument = _data["canViewListDocument"];
            this.canCreateDocument = _data["canCreateDocument"];
            this.canEditDocument = _data["canEditDocument"];
            this.canDeleteDocument = _data["canDeleteDocument"];
            this.documentCompilation = _data["documentCompilation"];
            this.canExport = _data["canExport"];
        }
    }

    static fromJS(data: any): AssignedUserCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedUserCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["canViewListPractice"] = this.canViewListPractice;
        data["canCreatePractice"] = this.canCreatePractice;
        data["canEditPractice"] = this.canEditPractice;
        data["canDeletePractice"] = this.canDeletePractice;
        data["canViewListTemplate"] = this.canViewListTemplate;
        data["canCreateTemplate"] = this.canCreateTemplate;
        data["canEditTemplate"] = this.canEditTemplate;
        data["canDeleteTemplate"] = this.canDeleteTemplate;
        data["canViewListDocument"] = this.canViewListDocument;
        data["canCreateDocument"] = this.canCreateDocument;
        data["canEditDocument"] = this.canEditDocument;
        data["canDeleteDocument"] = this.canDeleteDocument;
        data["documentCompilation"] = this.documentCompilation;
        data["canExport"] = this.canExport;
        return data;
    }

    clone(): AssignedUserCustomer {
        const json = this.toJSON();
        let result = new AssignedUserCustomer();
        result.init(json);
        return result;
    }
}

export interface IAssignedUserCustomer {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    user: User;
    customer: Customer;
    canViewListPractice: boolean;
    canCreatePractice: boolean;
    canEditPractice: boolean;
    canDeletePractice: boolean;
    canViewListTemplate: boolean;
    canCreateTemplate: boolean;
    canEditTemplate: boolean;
    canDeleteTemplate: boolean;
    canViewListDocument: boolean;
    canCreateDocument: boolean;
    canEditDocument: boolean;
    canDeleteDocument: boolean;
    documentCompilation: boolean;
    canExport: boolean;
}

export class AssignedUserCustomerDto implements IAssignedUserCustomerDto {
    id!: number;
    user!: UserDto;
    customer!: CustomerDto;
    canViewListPractice!: boolean;
    canCreatePractice!: boolean;
    canEditPractice!: boolean;
    canDeletePractice!: boolean;
    canViewListTemplate!: boolean;
    canCreateTemplate!: boolean;
    canEditTemplate!: boolean;
    canDeleteTemplate!: boolean;
    canViewListDocument!: boolean;
    canCreateDocument!: boolean;
    canEditDocument!: boolean;
    canDeleteDocument!: boolean;
    documentCompilation!: boolean;
    canExport!: boolean;

    constructor(data?: IAssignedUserCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : undefined as any;
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : undefined as any;
            this.canViewListPractice = _data["canViewListPractice"];
            this.canCreatePractice = _data["canCreatePractice"];
            this.canEditPractice = _data["canEditPractice"];
            this.canDeletePractice = _data["canDeletePractice"];
            this.canViewListTemplate = _data["canViewListTemplate"];
            this.canCreateTemplate = _data["canCreateTemplate"];
            this.canEditTemplate = _data["canEditTemplate"];
            this.canDeleteTemplate = _data["canDeleteTemplate"];
            this.canViewListDocument = _data["canViewListDocument"];
            this.canCreateDocument = _data["canCreateDocument"];
            this.canEditDocument = _data["canEditDocument"];
            this.canDeleteDocument = _data["canDeleteDocument"];
            this.documentCompilation = _data["documentCompilation"];
            this.canExport = _data["canExport"];
        }
    }

    static fromJS(data: any): AssignedUserCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedUserCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["canViewListPractice"] = this.canViewListPractice;
        data["canCreatePractice"] = this.canCreatePractice;
        data["canEditPractice"] = this.canEditPractice;
        data["canDeletePractice"] = this.canDeletePractice;
        data["canViewListTemplate"] = this.canViewListTemplate;
        data["canCreateTemplate"] = this.canCreateTemplate;
        data["canEditTemplate"] = this.canEditTemplate;
        data["canDeleteTemplate"] = this.canDeleteTemplate;
        data["canViewListDocument"] = this.canViewListDocument;
        data["canCreateDocument"] = this.canCreateDocument;
        data["canEditDocument"] = this.canEditDocument;
        data["canDeleteDocument"] = this.canDeleteDocument;
        data["documentCompilation"] = this.documentCompilation;
        data["canExport"] = this.canExport;
        return data;
    }

    clone(): AssignedUserCustomerDto {
        const json = this.toJSON();
        let result = new AssignedUserCustomerDto();
        result.init(json);
        return result;
    }
}

export interface IAssignedUserCustomerDto {
    id: number;
    user: UserDto;
    customer: CustomerDto;
    canViewListPractice: boolean;
    canCreatePractice: boolean;
    canEditPractice: boolean;
    canDeletePractice: boolean;
    canViewListTemplate: boolean;
    canCreateTemplate: boolean;
    canEditTemplate: boolean;
    canDeleteTemplate: boolean;
    canViewListDocument: boolean;
    canCreateDocument: boolean;
    canEditDocument: boolean;
    canDeleteDocument: boolean;
    documentCompilation: boolean;
    canExport: boolean;
}

export class AssignedUserCustomerItemDto implements IAssignedUserCustomerItemDto {
    id!: number;
    user!: UserDto;
    customer!: CustomerDto;
    canViewListPractice!: boolean;
    canCreatePractice!: boolean;
    canEditPractice!: boolean;
    canDeletePractice!: boolean;
    canViewListTemplate!: boolean;
    canCreateTemplate!: boolean;
    canEditTemplate!: boolean;
    canDeleteTemplate!: boolean;
    canViewListDocument!: boolean;
    canCreateDocument!: boolean;
    canEditDocument!: boolean;
    canDeleteDocument!: boolean;
    documentCompilation!: boolean;
    canExport!: boolean;

    constructor(data?: IAssignedUserCustomerItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : undefined as any;
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : undefined as any;
            this.canViewListPractice = _data["canViewListPractice"];
            this.canCreatePractice = _data["canCreatePractice"];
            this.canEditPractice = _data["canEditPractice"];
            this.canDeletePractice = _data["canDeletePractice"];
            this.canViewListTemplate = _data["canViewListTemplate"];
            this.canCreateTemplate = _data["canCreateTemplate"];
            this.canEditTemplate = _data["canEditTemplate"];
            this.canDeleteTemplate = _data["canDeleteTemplate"];
            this.canViewListDocument = _data["canViewListDocument"];
            this.canCreateDocument = _data["canCreateDocument"];
            this.canEditDocument = _data["canEditDocument"];
            this.canDeleteDocument = _data["canDeleteDocument"];
            this.documentCompilation = _data["documentCompilation"];
            this.canExport = _data["canExport"];
        }
    }

    static fromJS(data: any): AssignedUserCustomerItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedUserCustomerItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["canViewListPractice"] = this.canViewListPractice;
        data["canCreatePractice"] = this.canCreatePractice;
        data["canEditPractice"] = this.canEditPractice;
        data["canDeletePractice"] = this.canDeletePractice;
        data["canViewListTemplate"] = this.canViewListTemplate;
        data["canCreateTemplate"] = this.canCreateTemplate;
        data["canEditTemplate"] = this.canEditTemplate;
        data["canDeleteTemplate"] = this.canDeleteTemplate;
        data["canViewListDocument"] = this.canViewListDocument;
        data["canCreateDocument"] = this.canCreateDocument;
        data["canEditDocument"] = this.canEditDocument;
        data["canDeleteDocument"] = this.canDeleteDocument;
        data["documentCompilation"] = this.documentCompilation;
        data["canExport"] = this.canExport;
        return data;
    }

    clone(): AssignedUserCustomerItemDto {
        const json = this.toJSON();
        let result = new AssignedUserCustomerItemDto();
        result.init(json);
        return result;
    }
}

export interface IAssignedUserCustomerItemDto {
    id: number;
    user: UserDto;
    customer: CustomerDto;
    canViewListPractice: boolean;
    canCreatePractice: boolean;
    canEditPractice: boolean;
    canDeletePractice: boolean;
    canViewListTemplate: boolean;
    canCreateTemplate: boolean;
    canEditTemplate: boolean;
    canDeleteTemplate: boolean;
    canViewListDocument: boolean;
    canCreateDocument: boolean;
    canEditDocument: boolean;
    canDeleteDocument: boolean;
    documentCompilation: boolean;
    canExport: boolean;
}

export class AssignedUserCustomerItemDtoPagedResultDto implements IAssignedUserCustomerItemDtoPagedResultDto {
    items!: AssignedUserCustomerItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IAssignedUserCustomerItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AssignedUserCustomerItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AssignedUserCustomerItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedUserCustomerItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AssignedUserCustomerItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AssignedUserCustomerItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAssignedUserCustomerItemDtoPagedResultDto {
    items: AssignedUserCustomerItemDto[] | undefined;
    totalCount: number;
}

export class AssignedUserPermissionsDto implements IAssignedUserPermissionsDto {
    id!: number;
    canViewListPractice!: boolean;
    canCreatePractice!: boolean;
    canEditPractice!: boolean;
    canDeletePractice!: boolean;
    canViewListTemplate!: boolean;
    canCreateTemplate!: boolean;
    canEditTemplate!: boolean;
    canDeleteTemplate!: boolean;
    canViewListDocument!: boolean;
    canCreateDocument!: boolean;
    canEditDocument!: boolean;
    canDeleteDocument!: boolean;
    canExport!: boolean;

    constructor(data?: IAssignedUserPermissionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.canViewListPractice = _data["canViewListPractice"];
            this.canCreatePractice = _data["canCreatePractice"];
            this.canEditPractice = _data["canEditPractice"];
            this.canDeletePractice = _data["canDeletePractice"];
            this.canViewListTemplate = _data["canViewListTemplate"];
            this.canCreateTemplate = _data["canCreateTemplate"];
            this.canEditTemplate = _data["canEditTemplate"];
            this.canDeleteTemplate = _data["canDeleteTemplate"];
            this.canViewListDocument = _data["canViewListDocument"];
            this.canCreateDocument = _data["canCreateDocument"];
            this.canEditDocument = _data["canEditDocument"];
            this.canDeleteDocument = _data["canDeleteDocument"];
            this.canExport = _data["canExport"];
        }
    }

    static fromJS(data: any): AssignedUserPermissionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedUserPermissionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["canViewListPractice"] = this.canViewListPractice;
        data["canCreatePractice"] = this.canCreatePractice;
        data["canEditPractice"] = this.canEditPractice;
        data["canDeletePractice"] = this.canDeletePractice;
        data["canViewListTemplate"] = this.canViewListTemplate;
        data["canCreateTemplate"] = this.canCreateTemplate;
        data["canEditTemplate"] = this.canEditTemplate;
        data["canDeleteTemplate"] = this.canDeleteTemplate;
        data["canViewListDocument"] = this.canViewListDocument;
        data["canCreateDocument"] = this.canCreateDocument;
        data["canEditDocument"] = this.canEditDocument;
        data["canDeleteDocument"] = this.canDeleteDocument;
        data["canExport"] = this.canExport;
        return data;
    }

    clone(): AssignedUserPermissionsDto {
        const json = this.toJSON();
        let result = new AssignedUserPermissionsDto();
        result.init(json);
        return result;
    }
}

export interface IAssignedUserPermissionsDto {
    id: number;
    canViewListPractice: boolean;
    canCreatePractice: boolean;
    canEditPractice: boolean;
    canDeletePractice: boolean;
    canViewListTemplate: boolean;
    canCreateTemplate: boolean;
    canEditTemplate: boolean;
    canDeleteTemplate: boolean;
    canViewListDocument: boolean;
    canCreateDocument: boolean;
    canEditDocument: boolean;
    canDeleteDocument: boolean;
    canExport: boolean;
}

export class AssociateDocumentInput implements IAssociateDocumentInput {
    document!: Int64EntityDto;
    customer!: Int64EntityDto;

    constructor(data?: IAssociateDocumentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.document = _data["document"] ? Int64EntityDto.fromJS(_data["document"]) : undefined as any;
            this.customer = _data["customer"] ? Int64EntityDto.fromJS(_data["customer"]) : undefined as any;
        }
    }

    static fromJS(data: any): AssociateDocumentInput {
        data = typeof data === 'object' ? data : {};
        let result = new AssociateDocumentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["document"] = this.document ? this.document.toJSON() : undefined as any;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        return data;
    }

    clone(): AssociateDocumentInput {
        const json = this.toJSON();
        let result = new AssociateDocumentInput();
        result.init(json);
        return result;
    }
}

export interface IAssociateDocumentInput {
    document: Int64EntityDto;
    customer: Int64EntityDto;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress!: string;
    password!: string;
    rememberClient!: boolean;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.rememberClient = _data["rememberClient"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        return data;
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    userId!: number;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        return data;
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
}

export class ChangePasswordDto implements IChangePasswordDto {
    currentPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ChangePasswordDto {
        const json = this.toJSON();
        let result = new ChangePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDto {
    currentPassword: string;
    newPassword: string;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme!: string;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        return data;
    }

    clone(): ChangeUiThemeInput {
        const json = this.toJSON();
        let result = new ChangeUiThemeInput();
        result.init(json);
        return result;
    }
}

export interface IChangeUiThemeInput {
    theme: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName!: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class CheckPDFFilesResultDto implements ICheckPDFFilesResultDto {
    documentCompilationsTotalCount!: number;
    documentCompilationsCount!: number;
    filesCheckedCount!: number;
    incompatibleFilesCount!: number;
    readonly incompatibleFiles!: CheckPDFResultDto[] | undefined;

    constructor(data?: ICheckPDFFilesResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentCompilationsTotalCount = _data["documentCompilationsTotalCount"];
            this.documentCompilationsCount = _data["documentCompilationsCount"];
            this.filesCheckedCount = _data["filesCheckedCount"];
            this.incompatibleFilesCount = _data["incompatibleFilesCount"];
            if (Array.isArray(_data["incompatibleFiles"])) {
                (this as any).incompatibleFiles = [] as any;
                for (let item of _data["incompatibleFiles"])
                    (this as any).incompatibleFiles!.push(CheckPDFResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CheckPDFFilesResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckPDFFilesResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentCompilationsTotalCount"] = this.documentCompilationsTotalCount;
        data["documentCompilationsCount"] = this.documentCompilationsCount;
        data["filesCheckedCount"] = this.filesCheckedCount;
        data["incompatibleFilesCount"] = this.incompatibleFilesCount;
        if (Array.isArray(this.incompatibleFiles)) {
            data["incompatibleFiles"] = [];
            for (let item of this.incompatibleFiles)
                data["incompatibleFiles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CheckPDFFilesResultDto {
        const json = this.toJSON();
        let result = new CheckPDFFilesResultDto();
        result.init(json);
        return result;
    }
}

export interface ICheckPDFFilesResultDto {
    documentCompilationsTotalCount: number;
    documentCompilationsCount: number;
    filesCheckedCount: number;
    incompatibleFilesCount: number;
    incompatibleFiles: CheckPDFResultDto[] | undefined;
}

export class CheckPDFResultDto implements ICheckPDFResultDto {
    fileId!: number;
    paperworkName!: string | undefined;
    fileName!: string | undefined;
    exMessage!: string | undefined;

    constructor(data?: ICheckPDFResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.paperworkName = _data["paperworkName"];
            this.fileName = _data["fileName"];
            this.exMessage = _data["exMessage"];
        }
    }

    static fromJS(data: any): CheckPDFResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckPDFResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["paperworkName"] = this.paperworkName;
        data["fileName"] = this.fileName;
        data["exMessage"] = this.exMessage;
        return data;
    }

    clone(): CheckPDFResultDto {
        const json = this.toJSON();
        let result = new CheckPDFResultDto();
        result.init(json);
        return result;
    }
}

export interface ICheckPDFResultDto {
    fileId: number;
    paperworkName: string | undefined;
    fileName: string | undefined;
    exMessage: string | undefined;
}

export class CreateAssignedUserCustomerDto implements ICreateAssignedUserCustomerDto {
    userId!: number | undefined;
    user!: CreateUserDto;
    customerId!: number;
    canViewListPractice!: boolean;
    canCreatePractice!: boolean;
    canEditPractice!: boolean;
    canDeletePractice!: boolean;
    canViewListTemplate!: boolean;
    canCreateTemplate!: boolean;
    canEditTemplate!: boolean;
    canDeleteTemplate!: boolean;
    canViewListDocument!: boolean;
    canCreateDocument!: boolean;
    canEditDocument!: boolean;
    canDeleteDocument!: boolean;
    documentCompilation!: boolean;
    canExport!: boolean;

    constructor(data?: ICreateAssignedUserCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.user = _data["user"] ? CreateUserDto.fromJS(_data["user"]) : undefined as any;
            this.customerId = _data["customerId"];
            this.canViewListPractice = _data["canViewListPractice"];
            this.canCreatePractice = _data["canCreatePractice"];
            this.canEditPractice = _data["canEditPractice"];
            this.canDeletePractice = _data["canDeletePractice"];
            this.canViewListTemplate = _data["canViewListTemplate"];
            this.canCreateTemplate = _data["canCreateTemplate"];
            this.canEditTemplate = _data["canEditTemplate"];
            this.canDeleteTemplate = _data["canDeleteTemplate"];
            this.canViewListDocument = _data["canViewListDocument"];
            this.canCreateDocument = _data["canCreateDocument"];
            this.canEditDocument = _data["canEditDocument"];
            this.canDeleteDocument = _data["canDeleteDocument"];
            this.documentCompilation = _data["documentCompilation"];
            this.canExport = _data["canExport"];
        }
    }

    static fromJS(data: any): CreateAssignedUserCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAssignedUserCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["customerId"] = this.customerId;
        data["canViewListPractice"] = this.canViewListPractice;
        data["canCreatePractice"] = this.canCreatePractice;
        data["canEditPractice"] = this.canEditPractice;
        data["canDeletePractice"] = this.canDeletePractice;
        data["canViewListTemplate"] = this.canViewListTemplate;
        data["canCreateTemplate"] = this.canCreateTemplate;
        data["canEditTemplate"] = this.canEditTemplate;
        data["canDeleteTemplate"] = this.canDeleteTemplate;
        data["canViewListDocument"] = this.canViewListDocument;
        data["canCreateDocument"] = this.canCreateDocument;
        data["canEditDocument"] = this.canEditDocument;
        data["canDeleteDocument"] = this.canDeleteDocument;
        data["documentCompilation"] = this.documentCompilation;
        data["canExport"] = this.canExport;
        return data;
    }

    clone(): CreateAssignedUserCustomerDto {
        const json = this.toJSON();
        let result = new CreateAssignedUserCustomerDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAssignedUserCustomerDto {
    userId: number | undefined;
    user: CreateUserDto;
    customerId: number;
    canViewListPractice: boolean;
    canCreatePractice: boolean;
    canEditPractice: boolean;
    canDeletePractice: boolean;
    canViewListTemplate: boolean;
    canCreateTemplate: boolean;
    canEditTemplate: boolean;
    canDeleteTemplate: boolean;
    canViewListDocument: boolean;
    canCreateDocument: boolean;
    canEditDocument: boolean;
    canDeleteDocument: boolean;
    documentCompilation: boolean;
    canExport: boolean;
}

export class CreateCustomerDto implements ICreateCustomerDto {
    name!: string;
    customerCode!: string;

    constructor(data?: ICreateCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.customerCode = _data["customerCode"];
        }
    }

    static fromJS(data: any): CreateCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["customerCode"] = this.customerCode;
        return data;
    }

    clone(): CreateCustomerDto {
        const json = this.toJSON();
        let result = new CreateCustomerDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCustomerDto {
    name: string;
    customerCode: string;
}

export class CreateDocumentCompilationDto implements ICreateDocumentCompilationDto {
    paperwork!: Int64EntityDto;
    documentPaperworkTemplate!: Int64EntityDto;
    alternativeTitle!: string | undefined;
    customerId!: number;

    constructor(data?: ICreateDocumentCompilationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paperwork = _data["paperwork"] ? Int64EntityDto.fromJS(_data["paperwork"]) : undefined as any;
            this.documentPaperworkTemplate = _data["documentPaperworkTemplate"] ? Int64EntityDto.fromJS(_data["documentPaperworkTemplate"]) : undefined as any;
            this.alternativeTitle = _data["alternativeTitle"];
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): CreateDocumentCompilationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentCompilationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paperwork"] = this.paperwork ? this.paperwork.toJSON() : undefined as any;
        data["documentPaperworkTemplate"] = this.documentPaperworkTemplate ? this.documentPaperworkTemplate.toJSON() : undefined as any;
        data["alternativeTitle"] = this.alternativeTitle;
        data["customerId"] = this.customerId;
        return data;
    }

    clone(): CreateDocumentCompilationDto {
        const json = this.toJSON();
        let result = new CreateDocumentCompilationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateDocumentCompilationDto {
    paperwork: Int64EntityDto;
    documentPaperworkTemplate: Int64EntityDto;
    alternativeTitle: string | undefined;
    customerId: number;
}

export class CreateDocumentDto implements ICreateDocumentDto {
    name!: string;
    customerId!: number | undefined;
    dynamicProperties!: CreateDocumentDynamicPropertyDto[] | undefined;

    constructor(data?: ICreateDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.customerId = _data["customerId"];
            if (Array.isArray(_data["dynamicProperties"])) {
                this.dynamicProperties = [] as any;
                for (let item of _data["dynamicProperties"])
                    this.dynamicProperties!.push(CreateDocumentDynamicPropertyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["customerId"] = this.customerId;
        if (Array.isArray(this.dynamicProperties)) {
            data["dynamicProperties"] = [];
            for (let item of this.dynamicProperties)
                data["dynamicProperties"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreateDocumentDto {
        const json = this.toJSON();
        let result = new CreateDocumentDto();
        result.init(json);
        return result;
    }
}

export interface ICreateDocumentDto {
    name: string;
    customerId: number | undefined;
    dynamicProperties: CreateDocumentDynamicPropertyDto[] | undefined;
}

export class CreateDocumentDynamicPropertyDto implements ICreateDocumentDynamicPropertyDto {
    document!: Int64EntityDto;
    name!: string | undefined;
    type!: string | undefined;
    isRequired!: boolean;
    listItemValues!: string[] | undefined;
    isMultiSelect!: boolean;
    regex!: string | undefined;

    constructor(data?: ICreateDocumentDynamicPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.document = _data["document"] ? Int64EntityDto.fromJS(_data["document"]) : undefined as any;
            this.name = _data["name"];
            this.type = _data["type"];
            this.isRequired = _data["isRequired"];
            if (Array.isArray(_data["listItemValues"])) {
                this.listItemValues = [] as any;
                for (let item of _data["listItemValues"])
                    this.listItemValues!.push(item);
            }
            this.isMultiSelect = _data["isMultiSelect"];
            this.regex = _data["regex"];
        }
    }

    static fromJS(data: any): CreateDocumentDynamicPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentDynamicPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["document"] = this.document ? this.document.toJSON() : undefined as any;
        data["name"] = this.name;
        data["type"] = this.type;
        data["isRequired"] = this.isRequired;
        if (Array.isArray(this.listItemValues)) {
            data["listItemValues"] = [];
            for (let item of this.listItemValues)
                data["listItemValues"].push(item);
        }
        data["isMultiSelect"] = this.isMultiSelect;
        data["regex"] = this.regex;
        return data;
    }

    clone(): CreateDocumentDynamicPropertyDto {
        const json = this.toJSON();
        let result = new CreateDocumentDynamicPropertyDto();
        result.init(json);
        return result;
    }
}

export interface ICreateDocumentDynamicPropertyDto {
    document: Int64EntityDto;
    name: string | undefined;
    type: string | undefined;
    isRequired: boolean;
    listItemValues: string[] | undefined;
    isMultiSelect: boolean;
    regex: string | undefined;
}

export class CreateDocumentPaperworkTemplateDto implements ICreateDocumentPaperworkTemplateDto {
    name!: string | undefined;
    document!: Int64EntityDto;

    constructor(data?: ICreateDocumentPaperworkTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.document = _data["document"] ? Int64EntityDto.fromJS(_data["document"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateDocumentPaperworkTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentPaperworkTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["document"] = this.document ? this.document.toJSON() : undefined as any;
        return data;
    }

    clone(): CreateDocumentPaperworkTemplateDto {
        const json = this.toJSON();
        let result = new CreateDocumentPaperworkTemplateDto();
        result.init(json);
        return result;
    }
}

export interface ICreateDocumentPaperworkTemplateDto {
    name: string | undefined;
    document: Int64EntityDto;
}

export class CreatePaperworkDto implements ICreatePaperworkDto {
    title!: string | undefined;
    template!: Int64EntityDto;
    customer!: Int64EntityDto;
    note!: string | undefined;

    constructor(data?: ICreatePaperworkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.template = _data["template"] ? Int64EntityDto.fromJS(_data["template"]) : undefined as any;
            this.customer = _data["customer"] ? Int64EntityDto.fromJS(_data["customer"]) : undefined as any;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreatePaperworkDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaperworkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["template"] = this.template ? this.template.toJSON() : undefined as any;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["note"] = this.note;
        return data;
    }

    clone(): CreatePaperworkDto {
        const json = this.toJSON();
        let result = new CreatePaperworkDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePaperworkDto {
    title: string | undefined;
    template: Int64EntityDto;
    customer: Int64EntityDto;
    note: string | undefined;
}

export class CreatePaperworkTemplateDto implements ICreatePaperworkTemplateDto {
    name!: string | undefined;
    paperworkStates!: PaperworkStateDto[] | undefined;
    customer!: Int64EntityDto;
    documentsPaperworkTemplate!: CreateDocumentPaperworkTemplateDto[] | undefined;

    constructor(data?: ICreatePaperworkTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["paperworkStates"])) {
                this.paperworkStates = [] as any;
                for (let item of _data["paperworkStates"])
                    this.paperworkStates!.push(PaperworkStateDto.fromJS(item));
            }
            this.customer = _data["customer"] ? Int64EntityDto.fromJS(_data["customer"]) : undefined as any;
            if (Array.isArray(_data["documentsPaperworkTemplate"])) {
                this.documentsPaperworkTemplate = [] as any;
                for (let item of _data["documentsPaperworkTemplate"])
                    this.documentsPaperworkTemplate!.push(CreateDocumentPaperworkTemplateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreatePaperworkTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaperworkTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.paperworkStates)) {
            data["paperworkStates"] = [];
            for (let item of this.paperworkStates)
                data["paperworkStates"].push(item ? item.toJSON() : undefined as any);
        }
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        if (Array.isArray(this.documentsPaperworkTemplate)) {
            data["documentsPaperworkTemplate"] = [];
            for (let item of this.documentsPaperworkTemplate)
                data["documentsPaperworkTemplate"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreatePaperworkTemplateDto {
        const json = this.toJSON();
        let result = new CreatePaperworkTemplateDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePaperworkTemplateDto {
    name: string | undefined;
    paperworkStates: PaperworkStateDto[] | undefined;
    customer: Int64EntityDto;
    documentsPaperworkTemplate: CreateDocumentPaperworkTemplateDto[] | undefined;
}

export class CreateRoleDto implements ICreateRoleDto {
    name!: string;
    displayName!: string;
    normalizedName!: string | undefined;
    description!: string | undefined;
    grantedPermissions!: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class CreateTenantDto implements ICreateTenantDto {
    tenancyName!: string;
    name!: string;
    adminEmailAddress!: string;
    connectionString!: string | undefined;
    isActive!: boolean;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;
}

export class CreateUpdateDynamicPropertyCompilationDto implements ICreateUpdateDynamicPropertyCompilationDto {
    id!: number;
    dynamicProperty!: Int64EntityDto;
    value!: string | undefined;
    selectedListItemIds!: number[] | undefined;

    constructor(data?: ICreateUpdateDynamicPropertyCompilationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dynamicProperty = _data["dynamicProperty"] ? Int64EntityDto.fromJS(_data["dynamicProperty"]) : undefined as any;
            this.value = _data["value"];
            if (Array.isArray(_data["selectedListItemIds"])) {
                this.selectedListItemIds = [] as any;
                for (let item of _data["selectedListItemIds"])
                    this.selectedListItemIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateUpdateDynamicPropertyCompilationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateDynamicPropertyCompilationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dynamicProperty"] = this.dynamicProperty ? this.dynamicProperty.toJSON() : undefined as any;
        data["value"] = this.value;
        if (Array.isArray(this.selectedListItemIds)) {
            data["selectedListItemIds"] = [];
            for (let item of this.selectedListItemIds)
                data["selectedListItemIds"].push(item);
        }
        return data;
    }

    clone(): CreateUpdateDynamicPropertyCompilationDto {
        const json = this.toJSON();
        let result = new CreateUpdateDynamicPropertyCompilationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUpdateDynamicPropertyCompilationDto {
    id: number;
    dynamicProperty: Int64EntityDto;
    value: string | undefined;
    selectedListItemIds: number[] | undefined;
}

export class CreateUserDto implements ICreateUserDto {
    name!: string;
    surname!: string | undefined;
    emailAddress!: string;
    phoneNumber!: string | undefined;
    isActive!: boolean;
    roleNames!: string[] | undefined;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        return data;
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    name: string;
    surname: string | undefined;
    emailAddress: string;
    phoneNumber: string | undefined;
    isActive: boolean;
    roleNames: string[] | undefined;
}

export class Customer implements ICustomer {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    name!: string | undefined;
    customerCode!: string | undefined;
    assignedUserCustomers!: AssignedUserCustomer[] | undefined;

    constructor(data?: ICustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.name = _data["name"];
            this.customerCode = _data["customerCode"];
            if (Array.isArray(_data["assignedUserCustomers"])) {
                this.assignedUserCustomers = [] as any;
                for (let item of _data["assignedUserCustomers"])
                    this.assignedUserCustomers!.push(AssignedUserCustomer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["name"] = this.name;
        data["customerCode"] = this.customerCode;
        if (Array.isArray(this.assignedUserCustomers)) {
            data["assignedUserCustomers"] = [];
            for (let item of this.assignedUserCustomers)
                data["assignedUserCustomers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): Customer {
        const json = this.toJSON();
        let result = new Customer();
        result.init(json);
        return result;
    }
}

export interface ICustomer {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string | undefined;
    customerCode: string | undefined;
    assignedUserCustomers: AssignedUserCustomer[] | undefined;
}

export class CustomerDto implements ICustomerDto {
    id!: number;
    name!: string | undefined;
    customerCode!: string | undefined;

    constructor(data?: ICustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.customerCode = _data["customerCode"];
        }
    }

    static fromJS(data: any): CustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["customerCode"] = this.customerCode;
        return data;
    }

    clone(): CustomerDto {
        const json = this.toJSON();
        let result = new CustomerDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerDto {
    id: number;
    name: string | undefined;
    customerCode: string | undefined;
}

export class CustomerDtoPagedResultDto implements ICustomerDtoPagedResultDto {
    items!: CustomerDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomerDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CustomerDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomerDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CustomerDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CustomerDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerDtoPagedResultDto {
    items: CustomerDto[] | undefined;
    totalCount: number;
}

export class CustomerItemDto implements ICustomerItemDto {
    id!: number;
    name!: string | undefined;
    customerCode!: string | undefined;

    constructor(data?: ICustomerItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.customerCode = _data["customerCode"];
        }
    }

    static fromJS(data: any): CustomerItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["customerCode"] = this.customerCode;
        return data;
    }

    clone(): CustomerItemDto {
        const json = this.toJSON();
        let result = new CustomerItemDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerItemDto {
    id: number;
    name: string | undefined;
    customerCode: string | undefined;
}

export class CustomerItemDtoPagedResultDto implements ICustomerItemDtoPagedResultDto {
    items!: CustomerItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomerItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CustomerItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomerItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CustomerItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CustomerItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerItemDtoPagedResultDto {
    items: CustomerItemDto[] | undefined;
    totalCount: number;
}

export class DictionaryDto implements IDictionaryDto {
    id!: number;
    description!: string | undefined;
    staticCode!: string | undefined;

    constructor(data?: IDictionaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
        }
    }

    static fromJS(data: any): DictionaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new DictionaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        return data;
    }

    clone(): DictionaryDto {
        const json = this.toJSON();
        let result = new DictionaryDto();
        result.init(json);
        return result;
    }
}

export interface IDictionaryDto {
    id: number;
    description: string | undefined;
    staticCode: string | undefined;
}

export class DictionaryDtoPagedResultDto implements IDictionaryDtoPagedResultDto {
    items!: DictionaryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IDictionaryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DictionaryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DictionaryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DictionaryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DictionaryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DictionaryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDictionaryDtoPagedResultDto {
    items: DictionaryDto[] | undefined;
    totalCount: number;
}

export class Document implements IDocument {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    name!: string | undefined;
    dynamicProperties!: DocumentDynamicProperty[] | undefined;
    customer!: Customer;
    documentPaperworkTemplates!: DocumentPaperworkTemplate[] | undefined;
    parent!: Document;

    constructor(data?: IDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.name = _data["name"];
            if (Array.isArray(_data["dynamicProperties"])) {
                this.dynamicProperties = [] as any;
                for (let item of _data["dynamicProperties"])
                    this.dynamicProperties!.push(DocumentDynamicProperty.fromJS(item));
            }
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : undefined as any;
            if (Array.isArray(_data["documentPaperworkTemplates"])) {
                this.documentPaperworkTemplates = [] as any;
                for (let item of _data["documentPaperworkTemplates"])
                    this.documentPaperworkTemplates!.push(DocumentPaperworkTemplate.fromJS(item));
            }
            this.parent = _data["parent"] ? Document.fromJS(_data["parent"]) : undefined as any;
        }
    }

    static fromJS(data: any): Document {
        data = typeof data === 'object' ? data : {};
        let result = new Document();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["name"] = this.name;
        if (Array.isArray(this.dynamicProperties)) {
            data["dynamicProperties"] = [];
            for (let item of this.dynamicProperties)
                data["dynamicProperties"].push(item ? item.toJSON() : undefined as any);
        }
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        if (Array.isArray(this.documentPaperworkTemplates)) {
            data["documentPaperworkTemplates"] = [];
            for (let item of this.documentPaperworkTemplates)
                data["documentPaperworkTemplates"].push(item ? item.toJSON() : undefined as any);
        }
        data["parent"] = this.parent ? this.parent.toJSON() : undefined as any;
        return data;
    }

    clone(): Document {
        const json = this.toJSON();
        let result = new Document();
        result.init(json);
        return result;
    }
}

export interface IDocument {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string | undefined;
    dynamicProperties: DocumentDynamicProperty[] | undefined;
    customer: Customer;
    documentPaperworkTemplates: DocumentPaperworkTemplate[] | undefined;
    parent: Document;
}

export class DocumentCompilation implements IDocumentCompilation {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    documentPaperworkTemplate!: DocumentPaperworkTemplate;
    files!: File[] | undefined;
    dynamicPropertyCompilations!: DynamicPropertyCompilation[] | undefined;
    paperwork!: Paperwork;
    alternativeTitle!: string | undefined;

    constructor(data?: IDocumentCompilation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.documentPaperworkTemplate = _data["documentPaperworkTemplate"] ? DocumentPaperworkTemplate.fromJS(_data["documentPaperworkTemplate"]) : undefined as any;
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(File.fromJS(item));
            }
            if (Array.isArray(_data["dynamicPropertyCompilations"])) {
                this.dynamicPropertyCompilations = [] as any;
                for (let item of _data["dynamicPropertyCompilations"])
                    this.dynamicPropertyCompilations!.push(DynamicPropertyCompilation.fromJS(item));
            }
            this.paperwork = _data["paperwork"] ? Paperwork.fromJS(_data["paperwork"]) : undefined as any;
            this.alternativeTitle = _data["alternativeTitle"];
        }
    }

    static fromJS(data: any): DocumentCompilation {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentCompilation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["documentPaperworkTemplate"] = this.documentPaperworkTemplate ? this.documentPaperworkTemplate.toJSON() : undefined as any;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dynamicPropertyCompilations)) {
            data["dynamicPropertyCompilations"] = [];
            for (let item of this.dynamicPropertyCompilations)
                data["dynamicPropertyCompilations"].push(item ? item.toJSON() : undefined as any);
        }
        data["paperwork"] = this.paperwork ? this.paperwork.toJSON() : undefined as any;
        data["alternativeTitle"] = this.alternativeTitle;
        return data;
    }

    clone(): DocumentCompilation {
        const json = this.toJSON();
        let result = new DocumentCompilation();
        result.init(json);
        return result;
    }
}

export interface IDocumentCompilation {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    documentPaperworkTemplate: DocumentPaperworkTemplate;
    files: File[] | undefined;
    dynamicPropertyCompilations: DynamicPropertyCompilation[] | undefined;
    paperwork: Paperwork;
    alternativeTitle: string | undefined;
}

export class DocumentCompilationDto implements IDocumentCompilationDto {
    id!: number;
    documentPaperworkTemplate!: DocumentPaperworkTemplateDto;
    files!: FileDto[] | undefined;
    dynamicPropertyCompilations!: DynamicPropertyCompilationDto[] | undefined;
    alternativeTitle!: string | undefined;
    customer!: CustomerDto;

    constructor(data?: IDocumentCompilationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentPaperworkTemplate = _data["documentPaperworkTemplate"] ? DocumentPaperworkTemplateDto.fromJS(_data["documentPaperworkTemplate"]) : undefined as any;
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileDto.fromJS(item));
            }
            if (Array.isArray(_data["dynamicPropertyCompilations"])) {
                this.dynamicPropertyCompilations = [] as any;
                for (let item of _data["dynamicPropertyCompilations"])
                    this.dynamicPropertyCompilations!.push(DynamicPropertyCompilationDto.fromJS(item));
            }
            this.alternativeTitle = _data["alternativeTitle"];
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : undefined as any;
        }
    }

    static fromJS(data: any): DocumentCompilationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentCompilationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentPaperworkTemplate"] = this.documentPaperworkTemplate ? this.documentPaperworkTemplate.toJSON() : undefined as any;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dynamicPropertyCompilations)) {
            data["dynamicPropertyCompilations"] = [];
            for (let item of this.dynamicPropertyCompilations)
                data["dynamicPropertyCompilations"].push(item ? item.toJSON() : undefined as any);
        }
        data["alternativeTitle"] = this.alternativeTitle;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        return data;
    }

    clone(): DocumentCompilationDto {
        const json = this.toJSON();
        let result = new DocumentCompilationDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentCompilationDto {
    id: number;
    documentPaperworkTemplate: DocumentPaperworkTemplateDto;
    files: FileDto[] | undefined;
    dynamicPropertyCompilations: DynamicPropertyCompilationDto[] | undefined;
    alternativeTitle: string | undefined;
    customer: CustomerDto;
}

export class DocumentCompilationItemDto implements IDocumentCompilationItemDto {
    id!: number;
    documentPaperworkTemplate!: DocumentPaperworkTemplateDto;
    lastFileInsertDate!: moment.Moment | undefined;
    lastFileEditDate!: moment.Moment | undefined;
    alternativeTitle!: string | undefined;
    paperwork!: PaperworkItemDto;

    constructor(data?: IDocumentCompilationItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentPaperworkTemplate = _data["documentPaperworkTemplate"] ? DocumentPaperworkTemplateDto.fromJS(_data["documentPaperworkTemplate"]) : undefined as any;
            this.lastFileInsertDate = _data["lastFileInsertDate"] ? moment(_data["lastFileInsertDate"].toString()) : undefined as any;
            this.lastFileEditDate = _data["lastFileEditDate"] ? moment(_data["lastFileEditDate"].toString()) : undefined as any;
            this.alternativeTitle = _data["alternativeTitle"];
            this.paperwork = _data["paperwork"] ? PaperworkItemDto.fromJS(_data["paperwork"]) : undefined as any;
        }
    }

    static fromJS(data: any): DocumentCompilationItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentCompilationItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentPaperworkTemplate"] = this.documentPaperworkTemplate ? this.documentPaperworkTemplate.toJSON() : undefined as any;
        data["lastFileInsertDate"] = this.lastFileInsertDate ? this.lastFileInsertDate.toISOString() : undefined as any;
        data["lastFileEditDate"] = this.lastFileEditDate ? this.lastFileEditDate.toISOString() : undefined as any;
        data["alternativeTitle"] = this.alternativeTitle;
        data["paperwork"] = this.paperwork ? this.paperwork.toJSON() : undefined as any;
        return data;
    }

    clone(): DocumentCompilationItemDto {
        const json = this.toJSON();
        let result = new DocumentCompilationItemDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentCompilationItemDto {
    id: number;
    documentPaperworkTemplate: DocumentPaperworkTemplateDto;
    lastFileInsertDate: moment.Moment | undefined;
    lastFileEditDate: moment.Moment | undefined;
    alternativeTitle: string | undefined;
    paperwork: PaperworkItemDto;
}

export class DocumentCompilationItemDtoPagedResultDto implements IDocumentCompilationItemDtoPagedResultDto {
    items!: DocumentCompilationItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IDocumentCompilationItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DocumentCompilationItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DocumentCompilationItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentCompilationItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DocumentCompilationItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DocumentCompilationItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentCompilationItemDtoPagedResultDto {
    items: DocumentCompilationItemDto[] | undefined;
    totalCount: number;
}

export class DocumentDto implements IDocumentDto {
    id!: number;
    name!: string | undefined;
    customer!: CustomerItemDto;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.customer = _data["customer"] ? CustomerItemDto.fromJS(_data["customer"]) : undefined as any;
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        return data;
    }

    clone(): DocumentDto {
        const json = this.toJSON();
        let result = new DocumentDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentDto {
    id: number;
    name: string | undefined;
    customer: CustomerItemDto;
}

export class DocumentDynamicProperty implements IDocumentDynamicProperty {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    document!: Document;
    name!: string | undefined;
    type!: string | undefined;
    isRequired!: boolean;
    listItems!: DocumentDynamicPropertyListItem[] | undefined;
    isMultiSelect!: boolean;
    regex!: string | undefined;

    constructor(data?: IDocumentDynamicProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : undefined as any;
            this.name = _data["name"];
            this.type = _data["type"];
            this.isRequired = _data["isRequired"];
            if (Array.isArray(_data["listItems"])) {
                this.listItems = [] as any;
                for (let item of _data["listItems"])
                    this.listItems!.push(DocumentDynamicPropertyListItem.fromJS(item));
            }
            this.isMultiSelect = _data["isMultiSelect"];
            this.regex = _data["regex"];
        }
    }

    static fromJS(data: any): DocumentDynamicProperty {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDynamicProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["document"] = this.document ? this.document.toJSON() : undefined as any;
        data["name"] = this.name;
        data["type"] = this.type;
        data["isRequired"] = this.isRequired;
        if (Array.isArray(this.listItems)) {
            data["listItems"] = [];
            for (let item of this.listItems)
                data["listItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["isMultiSelect"] = this.isMultiSelect;
        data["regex"] = this.regex;
        return data;
    }

    clone(): DocumentDynamicProperty {
        const json = this.toJSON();
        let result = new DocumentDynamicProperty();
        result.init(json);
        return result;
    }
}

export interface IDocumentDynamicProperty {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    document: Document;
    name: string | undefined;
    type: string | undefined;
    isRequired: boolean;
    listItems: DocumentDynamicPropertyListItem[] | undefined;
    isMultiSelect: boolean;
    regex: string | undefined;
}

export class DocumentDynamicPropertyDto implements IDocumentDynamicPropertyDto {
    id!: number;
    document!: DocumentDto;
    name!: string | undefined;
    type!: string | undefined;
    isRequired!: boolean;
    documentListItems!: DictionaryDto[] | undefined;
    isMultiSelect!: boolean;
    regex!: string | undefined;

    constructor(data?: IDocumentDynamicPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.document = _data["document"] ? DocumentDto.fromJS(_data["document"]) : undefined as any;
            this.name = _data["name"];
            this.type = _data["type"];
            this.isRequired = _data["isRequired"];
            if (Array.isArray(_data["documentListItems"])) {
                this.documentListItems = [] as any;
                for (let item of _data["documentListItems"])
                    this.documentListItems!.push(DictionaryDto.fromJS(item));
            }
            this.isMultiSelect = _data["isMultiSelect"];
            this.regex = _data["regex"];
        }
    }

    static fromJS(data: any): DocumentDynamicPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDynamicPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["document"] = this.document ? this.document.toJSON() : undefined as any;
        data["name"] = this.name;
        data["type"] = this.type;
        data["isRequired"] = this.isRequired;
        if (Array.isArray(this.documentListItems)) {
            data["documentListItems"] = [];
            for (let item of this.documentListItems)
                data["documentListItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["isMultiSelect"] = this.isMultiSelect;
        data["regex"] = this.regex;
        return data;
    }

    clone(): DocumentDynamicPropertyDto {
        const json = this.toJSON();
        let result = new DocumentDynamicPropertyDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentDynamicPropertyDto {
    id: number;
    document: DocumentDto;
    name: string | undefined;
    type: string | undefined;
    isRequired: boolean;
    documentListItems: DictionaryDto[] | undefined;
    isMultiSelect: boolean;
    regex: string | undefined;
}

export class DocumentDynamicPropertyDtoPagedResultDto implements IDocumentDynamicPropertyDtoPagedResultDto {
    items!: DocumentDynamicPropertyDto[] | undefined;
    totalCount!: number;

    constructor(data?: IDocumentDynamicPropertyDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DocumentDynamicPropertyDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DocumentDynamicPropertyDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDynamicPropertyDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DocumentDynamicPropertyDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DocumentDynamicPropertyDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentDynamicPropertyDtoPagedResultDto {
    items: DocumentDynamicPropertyDto[] | undefined;
    totalCount: number;
}

export class DocumentDynamicPropertyListItem implements IDocumentDynamicPropertyListItem {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    documentDynamicProperty!: DocumentDynamicProperty;
    documentListItem!: DocumentListItem;

    constructor(data?: IDocumentDynamicPropertyListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.documentDynamicProperty = _data["documentDynamicProperty"] ? DocumentDynamicProperty.fromJS(_data["documentDynamicProperty"]) : undefined as any;
            this.documentListItem = _data["documentListItem"] ? DocumentListItem.fromJS(_data["documentListItem"]) : undefined as any;
        }
    }

    static fromJS(data: any): DocumentDynamicPropertyListItem {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDynamicPropertyListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["documentDynamicProperty"] = this.documentDynamicProperty ? this.documentDynamicProperty.toJSON() : undefined as any;
        data["documentListItem"] = this.documentListItem ? this.documentListItem.toJSON() : undefined as any;
        return data;
    }

    clone(): DocumentDynamicPropertyListItem {
        const json = this.toJSON();
        let result = new DocumentDynamicPropertyListItem();
        result.init(json);
        return result;
    }
}

export interface IDocumentDynamicPropertyListItem {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    documentDynamicProperty: DocumentDynamicProperty;
    documentListItem: DocumentListItem;
}

export class DocumentItemDto implements IDocumentItemDto {
    id!: number;
    name!: string | undefined;
    customer!: CustomerDto;

    constructor(data?: IDocumentItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : undefined as any;
        }
    }

    static fromJS(data: any): DocumentItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        return data;
    }

    clone(): DocumentItemDto {
        const json = this.toJSON();
        let result = new DocumentItemDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentItemDto {
    id: number;
    name: string | undefined;
    customer: CustomerDto;
}

export class DocumentItemDtoPagedResultDto implements IDocumentItemDtoPagedResultDto {
    items!: DocumentItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IDocumentItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DocumentItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DocumentItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DocumentItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DocumentItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentItemDtoPagedResultDto {
    items: DocumentItemDto[] | undefined;
    totalCount: number;
}

export class DocumentListItem implements IDocumentListItem {
    id!: number;
    description!: string;
    staticCode!: string | undefined;

    constructor(data?: IDocumentListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
        }
    }

    static fromJS(data: any): DocumentListItem {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        return data;
    }

    clone(): DocumentListItem {
        const json = this.toJSON();
        let result = new DocumentListItem();
        result.init(json);
        return result;
    }
}

export interface IDocumentListItem {
    id: number;
    description: string;
    staticCode: string | undefined;
}

export class DocumentPaperworkTemplate implements IDocumentPaperworkTemplate {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    documentSecondName!: string | undefined;
    template!: PaperworkTemplate;
    document!: Document;

    constructor(data?: IDocumentPaperworkTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.documentSecondName = _data["documentSecondName"];
            this.template = _data["template"] ? PaperworkTemplate.fromJS(_data["template"]) : undefined as any;
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : undefined as any;
        }
    }

    static fromJS(data: any): DocumentPaperworkTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentPaperworkTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["documentSecondName"] = this.documentSecondName;
        data["template"] = this.template ? this.template.toJSON() : undefined as any;
        data["document"] = this.document ? this.document.toJSON() : undefined as any;
        return data;
    }

    clone(): DocumentPaperworkTemplate {
        const json = this.toJSON();
        let result = new DocumentPaperworkTemplate();
        result.init(json);
        return result;
    }
}

export interface IDocumentPaperworkTemplate {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    documentSecondName: string | undefined;
    template: PaperworkTemplate;
    document: Document;
}

export class DocumentPaperworkTemplateDto implements IDocumentPaperworkTemplateDto {
    id!: number;
    documentSecondName!: string | undefined;
    document!: DocumentDto;

    constructor(data?: IDocumentPaperworkTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentSecondName = _data["documentSecondName"];
            this.document = _data["document"] ? DocumentDto.fromJS(_data["document"]) : undefined as any;
        }
    }

    static fromJS(data: any): DocumentPaperworkTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentPaperworkTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentSecondName"] = this.documentSecondName;
        data["document"] = this.document ? this.document.toJSON() : undefined as any;
        return data;
    }

    clone(): DocumentPaperworkTemplateDto {
        const json = this.toJSON();
        let result = new DocumentPaperworkTemplateDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentPaperworkTemplateDto {
    id: number;
    documentSecondName: string | undefined;
    document: DocumentDto;
}

export class DocumentPaperworkTemplateItemDto implements IDocumentPaperworkTemplateItemDto {
    id!: number;
    documentSecondName!: string | undefined;
    document!: DocumentItemDto;
    template!: PaperworkTemplateItemDto;

    constructor(data?: IDocumentPaperworkTemplateItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentSecondName = _data["documentSecondName"];
            this.document = _data["document"] ? DocumentItemDto.fromJS(_data["document"]) : undefined as any;
            this.template = _data["template"] ? PaperworkTemplateItemDto.fromJS(_data["template"]) : undefined as any;
        }
    }

    static fromJS(data: any): DocumentPaperworkTemplateItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentPaperworkTemplateItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentSecondName"] = this.documentSecondName;
        data["document"] = this.document ? this.document.toJSON() : undefined as any;
        data["template"] = this.template ? this.template.toJSON() : undefined as any;
        return data;
    }

    clone(): DocumentPaperworkTemplateItemDto {
        const json = this.toJSON();
        let result = new DocumentPaperworkTemplateItemDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentPaperworkTemplateItemDto {
    id: number;
    documentSecondName: string | undefined;
    document: DocumentItemDto;
    template: PaperworkTemplateItemDto;
}

export class DocumentPaperworkTemplateItemDtoPagedResultDto implements IDocumentPaperworkTemplateItemDtoPagedResultDto {
    items!: DocumentPaperworkTemplateItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IDocumentPaperworkTemplateItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DocumentPaperworkTemplateItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DocumentPaperworkTemplateItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentPaperworkTemplateItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DocumentPaperworkTemplateItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DocumentPaperworkTemplateItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentPaperworkTemplateItemDtoPagedResultDto {
    items: DocumentPaperworkTemplateItemDto[] | undefined;
    totalCount: number;
}

export class DynamicPropertyCompilation implements IDynamicPropertyCompilation {
    id!: number;
    dynamicProperty!: DocumentDynamicProperty;
    value!: string | undefined;
    documentCompilation!: DocumentCompilation;
    selectedListItems!: DocumentDynamicPropertyListItem[] | undefined;

    constructor(data?: IDynamicPropertyCompilation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dynamicProperty = _data["dynamicProperty"] ? DocumentDynamicProperty.fromJS(_data["dynamicProperty"]) : undefined as any;
            this.value = _data["value"];
            this.documentCompilation = _data["documentCompilation"] ? DocumentCompilation.fromJS(_data["documentCompilation"]) : undefined as any;
            if (Array.isArray(_data["selectedListItems"])) {
                this.selectedListItems = [] as any;
                for (let item of _data["selectedListItems"])
                    this.selectedListItems!.push(DocumentDynamicPropertyListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DynamicPropertyCompilation {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicPropertyCompilation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dynamicProperty"] = this.dynamicProperty ? this.dynamicProperty.toJSON() : undefined as any;
        data["value"] = this.value;
        data["documentCompilation"] = this.documentCompilation ? this.documentCompilation.toJSON() : undefined as any;
        if (Array.isArray(this.selectedListItems)) {
            data["selectedListItems"] = [];
            for (let item of this.selectedListItems)
                data["selectedListItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): DynamicPropertyCompilation {
        const json = this.toJSON();
        let result = new DynamicPropertyCompilation();
        result.init(json);
        return result;
    }
}

export interface IDynamicPropertyCompilation {
    id: number;
    dynamicProperty: DocumentDynamicProperty;
    value: string | undefined;
    documentCompilation: DocumentCompilation;
    selectedListItems: DocumentDynamicPropertyListItem[] | undefined;
}

export class DynamicPropertyCompilationDto implements IDynamicPropertyCompilationDto {
    id!: number;
    dynamicProperty!: DocumentDynamicPropertyDto;
    value!: string | undefined;

    constructor(data?: IDynamicPropertyCompilationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dynamicProperty = _data["dynamicProperty"] ? DocumentDynamicPropertyDto.fromJS(_data["dynamicProperty"]) : undefined as any;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DynamicPropertyCompilationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicPropertyCompilationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dynamicProperty"] = this.dynamicProperty ? this.dynamicProperty.toJSON() : undefined as any;
        data["value"] = this.value;
        return data;
    }

    clone(): DynamicPropertyCompilationDto {
        const json = this.toJSON();
        let result = new DynamicPropertyCompilationDto();
        result.init(json);
        return result;
    }
}

export interface IDynamicPropertyCompilationDto {
    id: number;
    dynamicProperty: DocumentDynamicPropertyDto;
    value: string | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider!: string;
    providerKey!: string;
    providerAccessCode!: string;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        return data;
    }

    clone(): ExternalAuthenticateModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    waitingForActivation!: boolean;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        return data;
    }

    clone(): ExternalAuthenticateResultModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name!: string | undefined;
    clientId!: string | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data;
    }

    clone(): ExternalLoginProviderInfoModel {
        const json = this.toJSON();
        let result = new ExternalLoginProviderInfoModel();
        result.init(json);
        return result;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
}

export class File implements IFile {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    mask!: string;
    name!: string | undefined;
    extension!: string | undefined;
    mimeType!: string | undefined;
    size!: number;
    documentCompilation!: DocumentCompilation;

    constructor(data?: IFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.mask = _data["mask"];
            this.name = _data["name"];
            this.extension = _data["extension"];
            this.mimeType = _data["mimeType"];
            this.size = _data["size"];
            this.documentCompilation = _data["documentCompilation"] ? DocumentCompilation.fromJS(_data["documentCompilation"]) : undefined as any;
        }
    }

    static fromJS(data: any): File {
        data = typeof data === 'object' ? data : {};
        let result = new File();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["mask"] = this.mask;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["mimeType"] = this.mimeType;
        data["size"] = this.size;
        data["documentCompilation"] = this.documentCompilation ? this.documentCompilation.toJSON() : undefined as any;
        return data;
    }

    clone(): File {
        const json = this.toJSON();
        let result = new File();
        result.init(json);
        return result;
    }
}

export interface IFile {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    mask: string;
    name: string | undefined;
    extension: string | undefined;
    mimeType: string | undefined;
    size: number;
    documentCompilation: DocumentCompilation;
}

export class FileDownloadDto implements IFileDownloadDto {
    id!: number;
    fileName!: string | undefined;
    mimeType!: string | undefined;
    size!: number;
    byteArray!: string | undefined;
    exportReportMessage!: string | undefined;

    constructor(data?: IFileDownloadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.mimeType = _data["mimeType"];
            this.size = _data["size"];
            this.byteArray = _data["byteArray"];
            this.exportReportMessage = _data["exportReportMessage"];
        }
    }

    static fromJS(data: any): FileDownloadDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDownloadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["mimeType"] = this.mimeType;
        data["size"] = this.size;
        data["byteArray"] = this.byteArray;
        data["exportReportMessage"] = this.exportReportMessage;
        return data;
    }

    clone(): FileDownloadDto {
        const json = this.toJSON();
        let result = new FileDownloadDto();
        result.init(json);
        return result;
    }
}

export interface IFileDownloadDto {
    id: number;
    fileName: string | undefined;
    mimeType: string | undefined;
    size: number;
    byteArray: string | undefined;
    exportReportMessage: string | undefined;
}

export class FileDto implements IFileDto {
    id!: number;
    mask!: string | undefined;
    name!: string | undefined;
    extension!: string | undefined;
    mineType!: string | undefined;
    size!: number;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mask = _data["mask"];
            this.name = _data["name"];
            this.extension = _data["extension"];
            this.mineType = _data["mineType"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mask"] = this.mask;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["mineType"] = this.mineType;
        data["size"] = this.size;
        return data;
    }

    clone(): FileDto {
        const json = this.toJSON();
        let result = new FileDto();
        result.init(json);
        return result;
    }
}

export interface IFileDto {
    id: number;
    mask: string | undefined;
    name: string | undefined;
    extension: string | undefined;
    mineType: string | undefined;
    size: number;
}

export class FileDtoPagedResultDto implements IFileDtoPagedResultDto {
    items!: FileDto[] | undefined;
    totalCount!: number;

    constructor(data?: IFileDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FileDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): FileDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): FileDtoPagedResultDto {
        const json = this.toJSON();
        let result = new FileDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IFileDtoPagedResultDto {
    items: FileDto[] | undefined;
    totalCount: number;
}

export class FileExcelDto implements IFileExcelDto {
    fileName!: string | undefined;
    fileData!: string | undefined;
    mimeType!: string | undefined;

    constructor(data?: IFileExcelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileData = _data["fileData"];
            this.mimeType = _data["mimeType"];
        }
    }

    static fromJS(data: any): FileExcelDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileExcelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileData"] = this.fileData;
        data["mimeType"] = this.mimeType;
        return data;
    }

    clone(): FileExcelDto {
        const json = this.toJSON();
        let result = new FileExcelDto();
        result.init(json);
        return result;
    }
}

export interface IFileExcelDto {
    fileName: string | undefined;
    fileData: string | undefined;
    mimeType: string | undefined;
}

export class FileExtendedDto implements IFileExtendedDto {
    byteArray!: string | undefined;
    signedUrl!: string | undefined;

    constructor(data?: IFileExtendedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.byteArray = _data["byteArray"];
            this.signedUrl = _data["signedUrl"];
        }
    }

    static fromJS(data: any): FileExtendedDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileExtendedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["byteArray"] = this.byteArray;
        data["signedUrl"] = this.signedUrl;
        return data;
    }

    clone(): FileExtendedDto {
        const json = this.toJSON();
        let result = new FileExtendedDto();
        result.init(json);
        return result;
    }
}

export interface IFileExtendedDto {
    byteArray: string | undefined;
    signedUrl: string | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }

    clone(): FlatPermissionDto {
        const json = this.toJSON();
        let result = new FlatPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class ForceResetPasswordDto implements IForceResetPasswordDto {
    adminPassword!: string;
    userId!: number;
    newPassword!: string;

    constructor(data?: IForceResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminPassword = _data["adminPassword"];
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ForceResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForceResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminPassword"] = this.adminPassword;
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ForceResetPasswordDto {
        const json = this.toJSON();
        let result = new ForceResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IForceResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;
}

export class ForgotPasswordDto implements IForgotPasswordDto {
    emailAddress!: string;

    constructor(data?: IForgotPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): ForgotPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }

    clone(): ForgotPasswordDto {
        const json = this.toJSON();
        let result = new ForgotPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IForgotPasswordDto {
    emailAddress: string;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application!: ApplicationInfoDto;
    user!: UserLoginInfoDto;
    tenant!: TenantLoginInfoDto;
    customer!: CustomerDto;
    assignedUser!: AssignedUserCustomerDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : undefined as any;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : undefined as any;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : undefined as any;
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : undefined as any;
            this.assignedUser = _data["assignedUser"] ? AssignedUserCustomerDto.fromJS(_data["assignedUser"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : undefined as any;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : undefined as any;
        return data;
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    customer: CustomerDto;
    assignedUser: AssignedUserCustomerDto;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role!: RoleEditDto;
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : undefined as any;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : undefined as any;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class IdentityError implements IIdentityError {
    code!: string | undefined;
    description!: string | undefined;

    constructor(data?: IIdentityError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): IdentityError {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }

    clone(): IdentityError {
        const json = this.toJSON();
        let result = new IdentityError();
        result.init(json);
        return result;
    }
}

export interface IIdentityError {
    code: string | undefined;
    description: string | undefined;
}

export class IdentityResult implements IIdentityResult {
    readonly succeeded!: boolean;
    readonly errors!: IdentityError[] | undefined;

    constructor(data?: IIdentityResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                (this as any).errors = [] as any;
                for (let item of _data["errors"])
                    (this as any).errors!.push(IdentityError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IdentityResult {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): IdentityResult {
        const json = this.toJSON();
        let result = new IdentityResult();
        result.init(json);
        return result;
    }
}

export interface IIdentityResult {
    succeeded: boolean;
    errors: IdentityError[] | undefined;
}

export class ImportErrorDto implements IImportErrorDto {
    row!: number;
    title!: string | undefined;
    message!: string | undefined;

    constructor(data?: IImportErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.row = _data["row"];
            this.title = _data["title"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ImportErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["row"] = this.row;
        data["title"] = this.title;
        data["message"] = this.message;
        return data;
    }

    clone(): ImportErrorDto {
        const json = this.toJSON();
        let result = new ImportErrorDto();
        result.init(json);
        return result;
    }
}

export interface IImportErrorDto {
    row: number;
    title: string | undefined;
    message: string | undefined;
}

export class ImportResultDto implements IImportResultDto {
    successCount!: number;
    errors!: ImportErrorDto[] | undefined;

    constructor(data?: IImportResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.successCount = _data["successCount"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ImportErrorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["successCount"] = this.successCount;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ImportResultDto {
        const json = this.toJSON();
        let result = new ImportResultDto();
        result.init(json);
        return result;
    }
}

export interface IImportResultDto {
    successCount: number;
    errors: ImportErrorDto[] | undefined;
}

export class Int32EntityDto implements IInt32EntityDto {
    id!: number;

    constructor(data?: IInt32EntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Int32EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int32EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): Int32EntityDto {
        const json = this.toJSON();
        let result = new Int32EntityDto();
        result.init(json);
        return result;
    }
}

export interface IInt32EntityDto {
    id: number;
}

export class Int64EntityDto implements IInt64EntityDto {
    id!: number;

    constructor(data?: IInt64EntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Int64EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int64EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): Int64EntityDto {
        const json = this.toJSON();
        let result = new Int64EntityDto();
        result.init(json);
        return result;
    }
}

export interface IInt64EntityDto {
    id: number;
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName!: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }

    clone(): IsTenantAvailableInput {
        const json = this.toJSON();
        let result = new IsTenantAvailableInput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state!: TenantAvailabilityState;
    tenantId!: number | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): IsTenantAvailableOutput {
        const json = this.toJSON();
        let result = new IsTenantAvailableOutput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
}

export class Paperwork implements IPaperwork {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    title!: string | undefined;
    template!: PaperworkTemplate;
    customer!: Customer;
    state!: PaperworkState;
    anomaly!: Anomaly;
    note!: string | undefined;
    documentCompilations!: DocumentCompilation[] | undefined;
    lastExportedAt!: moment.Moment | undefined;
    parentPaperwork!: Paperwork;
    childPaperwork!: Paperwork[] | undefined;
    stateLastUpdate!: moment.Moment | undefined;

    constructor(data?: IPaperwork) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.title = _data["title"];
            this.template = _data["template"] ? PaperworkTemplate.fromJS(_data["template"]) : undefined as any;
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : undefined as any;
            this.state = _data["state"] ? PaperworkState.fromJS(_data["state"]) : undefined as any;
            this.anomaly = _data["anomaly"] ? Anomaly.fromJS(_data["anomaly"]) : undefined as any;
            this.note = _data["note"];
            if (Array.isArray(_data["documentCompilations"])) {
                this.documentCompilations = [] as any;
                for (let item of _data["documentCompilations"])
                    this.documentCompilations!.push(DocumentCompilation.fromJS(item));
            }
            this.lastExportedAt = _data["lastExportedAt"] ? moment(_data["lastExportedAt"].toString()) : undefined as any;
            this.parentPaperwork = _data["parentPaperwork"] ? Paperwork.fromJS(_data["parentPaperwork"]) : undefined as any;
            if (Array.isArray(_data["childPaperwork"])) {
                this.childPaperwork = [] as any;
                for (let item of _data["childPaperwork"])
                    this.childPaperwork!.push(Paperwork.fromJS(item));
            }
            this.stateLastUpdate = _data["stateLastUpdate"] ? moment(_data["stateLastUpdate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Paperwork {
        data = typeof data === 'object' ? data : {};
        let result = new Paperwork();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["title"] = this.title;
        data["template"] = this.template ? this.template.toJSON() : undefined as any;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["state"] = this.state ? this.state.toJSON() : undefined as any;
        data["anomaly"] = this.anomaly ? this.anomaly.toJSON() : undefined as any;
        data["note"] = this.note;
        if (Array.isArray(this.documentCompilations)) {
            data["documentCompilations"] = [];
            for (let item of this.documentCompilations)
                data["documentCompilations"].push(item ? item.toJSON() : undefined as any);
        }
        data["lastExportedAt"] = this.lastExportedAt ? this.lastExportedAt.toISOString() : undefined as any;
        data["parentPaperwork"] = this.parentPaperwork ? this.parentPaperwork.toJSON() : undefined as any;
        if (Array.isArray(this.childPaperwork)) {
            data["childPaperwork"] = [];
            for (let item of this.childPaperwork)
                data["childPaperwork"].push(item ? item.toJSON() : undefined as any);
        }
        data["stateLastUpdate"] = this.stateLastUpdate ? this.stateLastUpdate.toISOString() : undefined as any;
        return data;
    }

    clone(): Paperwork {
        const json = this.toJSON();
        let result = new Paperwork();
        result.init(json);
        return result;
    }
}

export interface IPaperwork {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    title: string | undefined;
    template: PaperworkTemplate;
    customer: Customer;
    state: PaperworkState;
    anomaly: Anomaly;
    note: string | undefined;
    documentCompilations: DocumentCompilation[] | undefined;
    lastExportedAt: moment.Moment | undefined;
    parentPaperwork: Paperwork;
    childPaperwork: Paperwork[] | undefined;
    stateLastUpdate: moment.Moment | undefined;
}

export class PaperworkChildDto implements IPaperworkChildDto {
    id!: number;
    title!: string | undefined;

    constructor(data?: IPaperworkChildDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): PaperworkChildDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaperworkChildDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data;
    }

    clone(): PaperworkChildDto {
        const json = this.toJSON();
        let result = new PaperworkChildDto();
        result.init(json);
        return result;
    }
}

export interface IPaperworkChildDto {
    id: number;
    title: string | undefined;
}

export class PaperworkDto implements IPaperworkDto {
    id!: number;
    title!: string | undefined;
    template!: PaperworkTemplateDto;
    customer!: CustomerDto;
    state!: PaperworkStateDto;
    anomaly!: AnomalyDto;
    note!: string | undefined;
    newDocumentsPaperworkTamplate!: DocumentPaperworkTemplateDto[] | undefined;
    parentPaperworkId!: number | undefined;
    parentPaperworkTitle!: string | undefined;
    childPaperworks!: PaperworkChildDto[] | undefined;
    lastExportedAt!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    creationTime!: moment.Moment;
    lastModifierUserName!: string | undefined;
    stateLastUpdate!: moment.Moment | undefined;

    constructor(data?: IPaperworkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.template = _data["template"] ? PaperworkTemplateDto.fromJS(_data["template"]) : undefined as any;
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : undefined as any;
            this.state = _data["state"] ? PaperworkStateDto.fromJS(_data["state"]) : undefined as any;
            this.anomaly = _data["anomaly"] ? AnomalyDto.fromJS(_data["anomaly"]) : undefined as any;
            this.note = _data["note"];
            if (Array.isArray(_data["newDocumentsPaperworkTamplate"])) {
                this.newDocumentsPaperworkTamplate = [] as any;
                for (let item of _data["newDocumentsPaperworkTamplate"])
                    this.newDocumentsPaperworkTamplate!.push(DocumentPaperworkTemplateDto.fromJS(item));
            }
            this.parentPaperworkId = _data["parentPaperworkId"];
            this.parentPaperworkTitle = _data["parentPaperworkTitle"];
            if (Array.isArray(_data["childPaperworks"])) {
                this.childPaperworks = [] as any;
                for (let item of _data["childPaperworks"])
                    this.childPaperworks!.push(PaperworkChildDto.fromJS(item));
            }
            this.lastExportedAt = _data["lastExportedAt"] ? moment(_data["lastExportedAt"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.lastModifierUserName = _data["lastModifierUserName"];
            this.stateLastUpdate = _data["stateLastUpdate"] ? moment(_data["stateLastUpdate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PaperworkDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaperworkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["template"] = this.template ? this.template.toJSON() : undefined as any;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["state"] = this.state ? this.state.toJSON() : undefined as any;
        data["anomaly"] = this.anomaly ? this.anomaly.toJSON() : undefined as any;
        data["note"] = this.note;
        if (Array.isArray(this.newDocumentsPaperworkTamplate)) {
            data["newDocumentsPaperworkTamplate"] = [];
            for (let item of this.newDocumentsPaperworkTamplate)
                data["newDocumentsPaperworkTamplate"].push(item ? item.toJSON() : undefined as any);
        }
        data["parentPaperworkId"] = this.parentPaperworkId;
        data["parentPaperworkTitle"] = this.parentPaperworkTitle;
        if (Array.isArray(this.childPaperworks)) {
            data["childPaperworks"] = [];
            for (let item of this.childPaperworks)
                data["childPaperworks"].push(item ? item.toJSON() : undefined as any);
        }
        data["lastExportedAt"] = this.lastExportedAt ? this.lastExportedAt.toISOString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["lastModifierUserName"] = this.lastModifierUserName;
        data["stateLastUpdate"] = this.stateLastUpdate ? this.stateLastUpdate.toISOString() : undefined as any;
        return data;
    }

    clone(): PaperworkDto {
        const json = this.toJSON();
        let result = new PaperworkDto();
        result.init(json);
        return result;
    }
}

export interface IPaperworkDto {
    id: number;
    title: string | undefined;
    template: PaperworkTemplateDto;
    customer: CustomerDto;
    state: PaperworkStateDto;
    anomaly: AnomalyDto;
    note: string | undefined;
    newDocumentsPaperworkTamplate: DocumentPaperworkTemplateDto[] | undefined;
    parentPaperworkId: number | undefined;
    parentPaperworkTitle: string | undefined;
    childPaperworks: PaperworkChildDto[] | undefined;
    lastExportedAt: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    lastModifierUserName: string | undefined;
    stateLastUpdate: moment.Moment | undefined;
}

export class PaperworkDuplicateDto implements IPaperworkDuplicateDto {
    paperwork!: Int64EntityDto;
    title!: string | undefined;
    isIndependent!: boolean;
    inheritOriginalParent!: boolean;

    constructor(data?: IPaperworkDuplicateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paperwork = _data["paperwork"] ? Int64EntityDto.fromJS(_data["paperwork"]) : undefined as any;
            this.title = _data["title"];
            this.isIndependent = _data["isIndependent"];
            this.inheritOriginalParent = _data["inheritOriginalParent"];
        }
    }

    static fromJS(data: any): PaperworkDuplicateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaperworkDuplicateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paperwork"] = this.paperwork ? this.paperwork.toJSON() : undefined as any;
        data["title"] = this.title;
        data["isIndependent"] = this.isIndependent;
        data["inheritOriginalParent"] = this.inheritOriginalParent;
        return data;
    }

    clone(): PaperworkDuplicateDto {
        const json = this.toJSON();
        let result = new PaperworkDuplicateDto();
        result.init(json);
        return result;
    }
}

export interface IPaperworkDuplicateDto {
    paperwork: Int64EntityDto;
    title: string | undefined;
    isIndependent: boolean;
    inheritOriginalParent: boolean;
}

export class PaperworkItemDto implements IPaperworkItemDto {
    id!: number;
    title!: string | undefined;
    customer!: CustomerDto;
    state!: PaperworkStateDto;
    anomaly!: AnomalyDto;
    note!: string | undefined;
    template!: PaperworkTemplateItemDto;
    documentCompilations!: DocumentCompilationDto[] | undefined;
    parentPaperwork!: PaperworkParentDto;
    childPaperwork!: PaperworkParentDto[] | undefined;
    isFather!: boolean;
    isChild!: boolean;

    constructor(data?: IPaperworkItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : undefined as any;
            this.state = _data["state"] ? PaperworkStateDto.fromJS(_data["state"]) : undefined as any;
            this.anomaly = _data["anomaly"] ? AnomalyDto.fromJS(_data["anomaly"]) : undefined as any;
            this.note = _data["note"];
            this.template = _data["template"] ? PaperworkTemplateItemDto.fromJS(_data["template"]) : undefined as any;
            if (Array.isArray(_data["documentCompilations"])) {
                this.documentCompilations = [] as any;
                for (let item of _data["documentCompilations"])
                    this.documentCompilations!.push(DocumentCompilationDto.fromJS(item));
            }
            this.parentPaperwork = _data["parentPaperwork"] ? PaperworkParentDto.fromJS(_data["parentPaperwork"]) : undefined as any;
            if (Array.isArray(_data["childPaperwork"])) {
                this.childPaperwork = [] as any;
                for (let item of _data["childPaperwork"])
                    this.childPaperwork!.push(PaperworkParentDto.fromJS(item));
            }
            this.isFather = _data["isFather"];
            this.isChild = _data["isChild"];
        }
    }

    static fromJS(data: any): PaperworkItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaperworkItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["state"] = this.state ? this.state.toJSON() : undefined as any;
        data["anomaly"] = this.anomaly ? this.anomaly.toJSON() : undefined as any;
        data["note"] = this.note;
        data["template"] = this.template ? this.template.toJSON() : undefined as any;
        if (Array.isArray(this.documentCompilations)) {
            data["documentCompilations"] = [];
            for (let item of this.documentCompilations)
                data["documentCompilations"].push(item ? item.toJSON() : undefined as any);
        }
        data["parentPaperwork"] = this.parentPaperwork ? this.parentPaperwork.toJSON() : undefined as any;
        if (Array.isArray(this.childPaperwork)) {
            data["childPaperwork"] = [];
            for (let item of this.childPaperwork)
                data["childPaperwork"].push(item ? item.toJSON() : undefined as any);
        }
        data["isFather"] = this.isFather;
        data["isChild"] = this.isChild;
        return data;
    }

    clone(): PaperworkItemDto {
        const json = this.toJSON();
        let result = new PaperworkItemDto();
        result.init(json);
        return result;
    }
}

export interface IPaperworkItemDto {
    id: number;
    title: string | undefined;
    customer: CustomerDto;
    state: PaperworkStateDto;
    anomaly: AnomalyDto;
    note: string | undefined;
    template: PaperworkTemplateItemDto;
    documentCompilations: DocumentCompilationDto[] | undefined;
    parentPaperwork: PaperworkParentDto;
    childPaperwork: PaperworkParentDto[] | undefined;
    isFather: boolean;
    isChild: boolean;
}

export class PaperworkItemDtoPagedResultDto implements IPaperworkItemDtoPagedResultDto {
    items!: PaperworkItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPaperworkItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PaperworkItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PaperworkItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaperworkItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PaperworkItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PaperworkItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPaperworkItemDtoPagedResultDto {
    items: PaperworkItemDto[] | undefined;
    totalCount: number;
}

export class PaperworkLogDto implements IPaperworkLogDto {
    id!: number;
    paperwork!: Paperwork;
    customer!: Customer;
    operator!: string | undefined;
    typeLog!: TypeLog;
    date!: moment.Moment;

    constructor(data?: IPaperworkLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.paperwork = _data["paperwork"] ? Paperwork.fromJS(_data["paperwork"]) : undefined as any;
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : undefined as any;
            this.operator = _data["operator"];
            this.typeLog = _data["typeLog"] ? TypeLog.fromJS(_data["typeLog"]) : undefined as any;
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PaperworkLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaperworkLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["paperwork"] = this.paperwork ? this.paperwork.toJSON() : undefined as any;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["operator"] = this.operator;
        data["typeLog"] = this.typeLog ? this.typeLog.toJSON() : undefined as any;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        return data;
    }

    clone(): PaperworkLogDto {
        const json = this.toJSON();
        let result = new PaperworkLogDto();
        result.init(json);
        return result;
    }
}

export interface IPaperworkLogDto {
    id: number;
    paperwork: Paperwork;
    customer: Customer;
    operator: string | undefined;
    typeLog: TypeLog;
    date: moment.Moment;
}

export class PaperworkLogGetAllInput implements IPaperworkLogGetAllInput {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    paperworkId!: number;
    keyword!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    typeLogIds!: number[] | undefined;

    constructor(data?: IPaperworkLogGetAllInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.paperworkId = _data["paperworkId"];
            this.keyword = _data["keyword"];
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : undefined as any;
            if (Array.isArray(_data["typeLogIds"])) {
                this.typeLogIds = [] as any;
                for (let item of _data["typeLogIds"])
                    this.typeLogIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PaperworkLogGetAllInput {
        data = typeof data === 'object' ? data : {};
        let result = new PaperworkLogGetAllInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["paperworkId"] = this.paperworkId;
        data["keyword"] = this.keyword;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        if (Array.isArray(this.typeLogIds)) {
            data["typeLogIds"] = [];
            for (let item of this.typeLogIds)
                data["typeLogIds"].push(item);
        }
        return data;
    }

    clone(): PaperworkLogGetAllInput {
        const json = this.toJSON();
        let result = new PaperworkLogGetAllInput();
        result.init(json);
        return result;
    }
}

export interface IPaperworkLogGetAllInput {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    paperworkId: number;
    keyword: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    typeLogIds: number[] | undefined;
}

export class PaperworkLogItemDto implements IPaperworkLogItemDto {
    id!: number;
    paperworkId!: number;
    paperworkName!: string | undefined;
    customerName!: string | undefined;
    customerCode!: string | undefined;
    operator!: string | undefined;
    typeLogDescription!: string | undefined;
    date!: moment.Moment;

    constructor(data?: IPaperworkLogItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.paperworkId = _data["paperworkId"];
            this.paperworkName = _data["paperworkName"];
            this.customerName = _data["customerName"];
            this.customerCode = _data["customerCode"];
            this.operator = _data["operator"];
            this.typeLogDescription = _data["typeLogDescription"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PaperworkLogItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaperworkLogItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["paperworkId"] = this.paperworkId;
        data["paperworkName"] = this.paperworkName;
        data["customerName"] = this.customerName;
        data["customerCode"] = this.customerCode;
        data["operator"] = this.operator;
        data["typeLogDescription"] = this.typeLogDescription;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        return data;
    }

    clone(): PaperworkLogItemDto {
        const json = this.toJSON();
        let result = new PaperworkLogItemDto();
        result.init(json);
        return result;
    }
}

export interface IPaperworkLogItemDto {
    id: number;
    paperworkId: number;
    paperworkName: string | undefined;
    customerName: string | undefined;
    customerCode: string | undefined;
    operator: string | undefined;
    typeLogDescription: string | undefined;
    date: moment.Moment;
}

export class PaperworkLogItemDtoPagedResultDto implements IPaperworkLogItemDtoPagedResultDto {
    items!: PaperworkLogItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPaperworkLogItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PaperworkLogItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PaperworkLogItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaperworkLogItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PaperworkLogItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PaperworkLogItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPaperworkLogItemDtoPagedResultDto {
    items: PaperworkLogItemDto[] | undefined;
    totalCount: number;
}

export class PaperworkParentDto implements IPaperworkParentDto {
    id!: number;
    title!: string | undefined;

    constructor(data?: IPaperworkParentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): PaperworkParentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaperworkParentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data;
    }

    clone(): PaperworkParentDto {
        const json = this.toJSON();
        let result = new PaperworkParentDto();
        result.init(json);
        return result;
    }
}

export interface IPaperworkParentDto {
    id: number;
    title: string | undefined;
}

export class PaperworkParentDtoListResultDto implements IPaperworkParentDtoListResultDto {
    items!: PaperworkParentDto[] | undefined;

    constructor(data?: IPaperworkParentDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PaperworkParentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaperworkParentDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaperworkParentDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaperworkParentDtoListResultDto {
        const json = this.toJSON();
        let result = new PaperworkParentDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IPaperworkParentDtoListResultDto {
    items: PaperworkParentDto[] | undefined;
}

export class PaperworkState implements IPaperworkState {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    name!: string | undefined;
    templates!: PaperworkTemplate[] | undefined;

    constructor(data?: IPaperworkState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.name = _data["name"];
            if (Array.isArray(_data["templates"])) {
                this.templates = [] as any;
                for (let item of _data["templates"])
                    this.templates!.push(PaperworkTemplate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaperworkState {
        data = typeof data === 'object' ? data : {};
        let result = new PaperworkState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["name"] = this.name;
        if (Array.isArray(this.templates)) {
            data["templates"] = [];
            for (let item of this.templates)
                data["templates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaperworkState {
        const json = this.toJSON();
        let result = new PaperworkState();
        result.init(json);
        return result;
    }
}

export interface IPaperworkState {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string | undefined;
    templates: PaperworkTemplate[] | undefined;
}

export class PaperworkStateDto implements IPaperworkStateDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IPaperworkStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PaperworkStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaperworkStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): PaperworkStateDto {
        const json = this.toJSON();
        let result = new PaperworkStateDto();
        result.init(json);
        return result;
    }
}

export interface IPaperworkStateDto {
    id: number;
    name: string | undefined;
}

export class PaperworkStateDtoPagedResultDto implements IPaperworkStateDtoPagedResultDto {
    items!: PaperworkStateDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPaperworkStateDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PaperworkStateDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PaperworkStateDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaperworkStateDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PaperworkStateDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PaperworkStateDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPaperworkStateDtoPagedResultDto {
    items: PaperworkStateDto[] | undefined;
    totalCount: number;
}

export class PaperworkTemplate implements IPaperworkTemplate {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    name!: string | undefined;
    documentsPaperworkTemplate!: DocumentPaperworkTemplate[] | undefined;
    customer!: Customer;
    paperworkStates!: PaperworkState[] | undefined;
    paperworks!: Paperwork[] | undefined;

    constructor(data?: IPaperworkTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.name = _data["name"];
            if (Array.isArray(_data["documentsPaperworkTemplate"])) {
                this.documentsPaperworkTemplate = [] as any;
                for (let item of _data["documentsPaperworkTemplate"])
                    this.documentsPaperworkTemplate!.push(DocumentPaperworkTemplate.fromJS(item));
            }
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : undefined as any;
            if (Array.isArray(_data["paperworkStates"])) {
                this.paperworkStates = [] as any;
                for (let item of _data["paperworkStates"])
                    this.paperworkStates!.push(PaperworkState.fromJS(item));
            }
            if (Array.isArray(_data["paperworks"])) {
                this.paperworks = [] as any;
                for (let item of _data["paperworks"])
                    this.paperworks!.push(Paperwork.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaperworkTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new PaperworkTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["name"] = this.name;
        if (Array.isArray(this.documentsPaperworkTemplate)) {
            data["documentsPaperworkTemplate"] = [];
            for (let item of this.documentsPaperworkTemplate)
                data["documentsPaperworkTemplate"].push(item ? item.toJSON() : undefined as any);
        }
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        if (Array.isArray(this.paperworkStates)) {
            data["paperworkStates"] = [];
            for (let item of this.paperworkStates)
                data["paperworkStates"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.paperworks)) {
            data["paperworks"] = [];
            for (let item of this.paperworks)
                data["paperworks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaperworkTemplate {
        const json = this.toJSON();
        let result = new PaperworkTemplate();
        result.init(json);
        return result;
    }
}

export interface IPaperworkTemplate {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string | undefined;
    documentsPaperworkTemplate: DocumentPaperworkTemplate[] | undefined;
    customer: Customer;
    paperworkStates: PaperworkState[] | undefined;
    paperworks: Paperwork[] | undefined;
}

export class PaperworkTemplateDto implements IPaperworkTemplateDto {
    id!: number;
    name!: string | undefined;
    paperworkStates!: PaperworkStateDto[] | undefined;
    documentsPaperworkTemplate!: DocumentPaperworkTemplateDto[] | undefined;

    constructor(data?: IPaperworkTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["paperworkStates"])) {
                this.paperworkStates = [] as any;
                for (let item of _data["paperworkStates"])
                    this.paperworkStates!.push(PaperworkStateDto.fromJS(item));
            }
            if (Array.isArray(_data["documentsPaperworkTemplate"])) {
                this.documentsPaperworkTemplate = [] as any;
                for (let item of _data["documentsPaperworkTemplate"])
                    this.documentsPaperworkTemplate!.push(DocumentPaperworkTemplateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaperworkTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaperworkTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.paperworkStates)) {
            data["paperworkStates"] = [];
            for (let item of this.paperworkStates)
                data["paperworkStates"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.documentsPaperworkTemplate)) {
            data["documentsPaperworkTemplate"] = [];
            for (let item of this.documentsPaperworkTemplate)
                data["documentsPaperworkTemplate"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PaperworkTemplateDto {
        const json = this.toJSON();
        let result = new PaperworkTemplateDto();
        result.init(json);
        return result;
    }
}

export interface IPaperworkTemplateDto {
    id: number;
    name: string | undefined;
    paperworkStates: PaperworkStateDto[] | undefined;
    documentsPaperworkTemplate: DocumentPaperworkTemplateDto[] | undefined;
}

export class PaperworkTemplateItemDto implements IPaperworkTemplateItemDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IPaperworkTemplateItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PaperworkTemplateItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaperworkTemplateItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): PaperworkTemplateItemDto {
        const json = this.toJSON();
        let result = new PaperworkTemplateItemDto();
        result.init(json);
        return result;
    }
}

export interface IPaperworkTemplateItemDto {
    id: number;
    name: string | undefined;
}

export class PaperworkTemplateItemDtoPagedResultDto implements IPaperworkTemplateItemDtoPagedResultDto {
    items!: PaperworkTemplateItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPaperworkTemplateItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PaperworkTemplateItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PaperworkTemplateItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaperworkTemplateItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PaperworkTemplateItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PaperworkTemplateItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPaperworkTemplateItemDtoPagedResultDto {
    items: PaperworkTemplateItemDto[] | undefined;
    totalCount: number;
}

export class PermissionDto implements IPermissionDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }

    clone(): PermissionDto {
        const json = this.toJSON();
        let result = new PermissionDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class PermissionDtoListResultDto implements IPermissionDtoListResultDto {
    items!: PermissionDto[] | undefined;

    constructor(data?: IPermissionDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PermissionDtoListResultDto {
        const json = this.toJSON();
        let result = new PermissionDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;
}

export class RegisterInput implements IRegisterInput {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    password!: string;
    captchaResponse!: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }

    clone(): RegisterInput {
        const json = this.toJSON();
        let result = new RegisterInput();
        result.init(json);
        return result;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin!: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }

    clone(): RegisterOutput {
        const json = this.toJSON();
        let result = new RegisterOutput();
        result.init(json);
        return result;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class ResetPasswordResultDto implements IResetPasswordResultDto {
    result!: IdentityResult;
    userId!: number;
    isUserActive!: boolean;

    constructor(data?: IResetPasswordResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? IdentityResult.fromJS(_data["result"]) : undefined as any;
            this.userId = _data["userId"];
            this.isUserActive = _data["isUserActive"];
        }
    }

    static fromJS(data: any): ResetPasswordResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        data["userId"] = this.userId;
        data["isUserActive"] = this.isUserActive;
        return data;
    }

    clone(): ResetPasswordResultDto {
        const json = this.toJSON();
        let result = new ResetPasswordResultDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordResultDto {
    result: IdentityResult;
    userId: number;
    isUserActive: boolean;
}

export class RoleDto implements IRoleDto {
    id!: number;
    name!: string;
    displayName!: string;
    normalizedName!: string | undefined;
    description!: string | undefined;
    grantedPermissions!: string[] | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions!.push(item);
            }
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    id: number;
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
    items!: RoleDto[] | undefined;
    totalCount!: number;

    constructor(data?: IRoleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): RoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): RoleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RoleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoPagedResultDto {
    items: RoleDto[] | undefined;
    totalCount: number;
}

export class RoleEditDto implements IRoleEditDto {
    id!: number;
    name!: string;
    displayName!: string;
    description!: string | undefined;
    isStatic!: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        return data;
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    id: number;
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
}

export class RoleListDto implements IRoleListDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    isStatic!: boolean;
    isDefault!: boolean;
    creationTime!: moment.Moment;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        return data;
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
    items!: RoleListDto[] | undefined;

    constructor(data?: IRoleListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): RoleListDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleListDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;
}

export class SendReminderMailInput implements ISendReminderMailInput {
    assignedUserCustomers!: number[] | undefined;
    paperworkId!: number;

    constructor(data?: ISendReminderMailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assignedUserCustomers"])) {
                this.assignedUserCustomers = [] as any;
                for (let item of _data["assignedUserCustomers"])
                    this.assignedUserCustomers!.push(item);
            }
            this.paperworkId = _data["paperworkId"];
        }
    }

    static fromJS(data: any): SendReminderMailInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendReminderMailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assignedUserCustomers)) {
            data["assignedUserCustomers"] = [];
            for (let item of this.assignedUserCustomers)
                data["assignedUserCustomers"].push(item);
        }
        data["paperworkId"] = this.paperworkId;
        return data;
    }

    clone(): SendReminderMailInput {
        const json = this.toJSON();
        let result = new SendReminderMailInput();
        result.init(json);
        return result;
    }
}

export interface ISendReminderMailInput {
    assignedUserCustomers: number[] | undefined;
    paperworkId: number;
}

export class Setting implements ISetting {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    tenantId!: number | undefined;
    userId!: number | undefined;
    name!: string;
    value!: string | undefined;

    constructor(data?: ISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Setting {
        data = typeof data === 'object' ? data : {};
        let result = new Setting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): Setting {
        const json = this.toJSON();
        let result = new Setting();
        result.init(json);
        return result;
    }
}

export interface ISetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
}

export enum TenantAvailabilityState {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class TenantDto implements ITenantDto {
    id!: number;
    tenancyName!: string;
    name!: string;
    isActive!: boolean;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;
}

export class TenantDtoPagedResultDto implements ITenantDtoPagedResultDto {
    items!: TenantDto[] | undefined;
    totalCount!: number;

    constructor(data?: ITenantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TenantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TenantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TenantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDtoPagedResultDto {
    items: TenantDto[] | undefined;
    totalCount: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    id!: number;
    tenancyName!: string | undefined;
    name!: string | undefined;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        return data;
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;
}

export class TypeLog implements ITypeLog {
    id!: number;
    description!: string;
    staticCode!: string | undefined;

    constructor(data?: ITypeLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
        }
    }

    static fromJS(data: any): TypeLog {
        data = typeof data === 'object' ? data : {};
        let result = new TypeLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        return data;
    }

    clone(): TypeLog {
        const json = this.toJSON();
        let result = new TypeLog();
        result.init(json);
        return result;
    }
}

export interface ITypeLog {
    id: number;
    description: string;
    staticCode: string | undefined;
}

export class UpdateAssignedUserCustomerDto implements IUpdateAssignedUserCustomerDto {
    id!: number;
    userId!: number | undefined;
    emailUser!: string | undefined;
    canViewListPractice!: boolean;
    canCreatePractice!: boolean;
    canEditPractice!: boolean;
    canDeletePractice!: boolean;
    canViewListTemplate!: boolean;
    canCreateTemplate!: boolean;
    canEditTemplate!: boolean;
    canDeleteTemplate!: boolean;
    canViewListDocument!: boolean;
    canCreateDocument!: boolean;
    canEditDocument!: boolean;
    canDeleteDocument!: boolean;
    documentCompilation!: boolean;
    canExport!: boolean;

    constructor(data?: IUpdateAssignedUserCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.emailUser = _data["emailUser"];
            this.canViewListPractice = _data["canViewListPractice"];
            this.canCreatePractice = _data["canCreatePractice"];
            this.canEditPractice = _data["canEditPractice"];
            this.canDeletePractice = _data["canDeletePractice"];
            this.canViewListTemplate = _data["canViewListTemplate"];
            this.canCreateTemplate = _data["canCreateTemplate"];
            this.canEditTemplate = _data["canEditTemplate"];
            this.canDeleteTemplate = _data["canDeleteTemplate"];
            this.canViewListDocument = _data["canViewListDocument"];
            this.canCreateDocument = _data["canCreateDocument"];
            this.canEditDocument = _data["canEditDocument"];
            this.canDeleteDocument = _data["canDeleteDocument"];
            this.documentCompilation = _data["documentCompilation"];
            this.canExport = _data["canExport"];
        }
    }

    static fromJS(data: any): UpdateAssignedUserCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssignedUserCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["emailUser"] = this.emailUser;
        data["canViewListPractice"] = this.canViewListPractice;
        data["canCreatePractice"] = this.canCreatePractice;
        data["canEditPractice"] = this.canEditPractice;
        data["canDeletePractice"] = this.canDeletePractice;
        data["canViewListTemplate"] = this.canViewListTemplate;
        data["canCreateTemplate"] = this.canCreateTemplate;
        data["canEditTemplate"] = this.canEditTemplate;
        data["canDeleteTemplate"] = this.canDeleteTemplate;
        data["canViewListDocument"] = this.canViewListDocument;
        data["canCreateDocument"] = this.canCreateDocument;
        data["canEditDocument"] = this.canEditDocument;
        data["canDeleteDocument"] = this.canDeleteDocument;
        data["documentCompilation"] = this.documentCompilation;
        data["canExport"] = this.canExport;
        return data;
    }

    clone(): UpdateAssignedUserCustomerDto {
        const json = this.toJSON();
        let result = new UpdateAssignedUserCustomerDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAssignedUserCustomerDto {
    id: number;
    userId: number | undefined;
    emailUser: string | undefined;
    canViewListPractice: boolean;
    canCreatePractice: boolean;
    canEditPractice: boolean;
    canDeletePractice: boolean;
    canViewListTemplate: boolean;
    canCreateTemplate: boolean;
    canEditTemplate: boolean;
    canDeleteTemplate: boolean;
    canViewListDocument: boolean;
    canCreateDocument: boolean;
    canEditDocument: boolean;
    canDeleteDocument: boolean;
    documentCompilation: boolean;
    canExport: boolean;
}

export class UpdateCustomerDto implements IUpdateCustomerDto {
    id!: number;
    name!: string;
    customerCode!: string;

    constructor(data?: IUpdateCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.customerCode = _data["customerCode"];
        }
    }

    static fromJS(data: any): UpdateCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["customerCode"] = this.customerCode;
        return data;
    }

    clone(): UpdateCustomerDto {
        const json = this.toJSON();
        let result = new UpdateCustomerDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCustomerDto {
    id: number;
    name: string;
    customerCode: string;
}

export class UpdateDocumentCompilationDto implements IUpdateDocumentCompilationDto {
    id!: number;
    dynamicPropertyCompilations!: CreateUpdateDynamicPropertyCompilationDto[] | undefined;
    oldDocumentCompilation!: Int64EntityDto;
    file!: Int64EntityDto;
    customerId!: number;

    constructor(data?: IUpdateDocumentCompilationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["dynamicPropertyCompilations"])) {
                this.dynamicPropertyCompilations = [] as any;
                for (let item of _data["dynamicPropertyCompilations"])
                    this.dynamicPropertyCompilations!.push(CreateUpdateDynamicPropertyCompilationDto.fromJS(item));
            }
            this.oldDocumentCompilation = _data["oldDocumentCompilation"] ? Int64EntityDto.fromJS(_data["oldDocumentCompilation"]) : undefined as any;
            this.file = _data["file"] ? Int64EntityDto.fromJS(_data["file"]) : undefined as any;
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): UpdateDocumentCompilationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentCompilationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.dynamicPropertyCompilations)) {
            data["dynamicPropertyCompilations"] = [];
            for (let item of this.dynamicPropertyCompilations)
                data["dynamicPropertyCompilations"].push(item ? item.toJSON() : undefined as any);
        }
        data["oldDocumentCompilation"] = this.oldDocumentCompilation ? this.oldDocumentCompilation.toJSON() : undefined as any;
        data["file"] = this.file ? this.file.toJSON() : undefined as any;
        data["customerId"] = this.customerId;
        return data;
    }

    clone(): UpdateDocumentCompilationDto {
        const json = this.toJSON();
        let result = new UpdateDocumentCompilationDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateDocumentCompilationDto {
    id: number;
    dynamicPropertyCompilations: CreateUpdateDynamicPropertyCompilationDto[] | undefined;
    oldDocumentCompilation: Int64EntityDto;
    file: Int64EntityDto;
    customerId: number;
}

export class UpdateDocumentDto implements IUpdateDocumentDto {
    id!: number;
    name!: string;

    constructor(data?: IUpdateDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): UpdateDocumentDto {
        const json = this.toJSON();
        let result = new UpdateDocumentDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateDocumentDto {
    id: number;
    name: string;
}

export class UpdateDocumentDynamicPropertyDto implements IUpdateDocumentDynamicPropertyDto {
    id!: number;
    name!: string | undefined;
    type!: string | undefined;
    isRequired!: boolean;
    isMultiSelect!: boolean;
    listItemValues!: string[] | undefined;
    regex!: string | undefined;

    constructor(data?: IUpdateDocumentDynamicPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.isRequired = _data["isRequired"];
            this.isMultiSelect = _data["isMultiSelect"];
            if (Array.isArray(_data["listItemValues"])) {
                this.listItemValues = [] as any;
                for (let item of _data["listItemValues"])
                    this.listItemValues!.push(item);
            }
            this.regex = _data["regex"];
        }
    }

    static fromJS(data: any): UpdateDocumentDynamicPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentDynamicPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["isRequired"] = this.isRequired;
        data["isMultiSelect"] = this.isMultiSelect;
        if (Array.isArray(this.listItemValues)) {
            data["listItemValues"] = [];
            for (let item of this.listItemValues)
                data["listItemValues"].push(item);
        }
        data["regex"] = this.regex;
        return data;
    }

    clone(): UpdateDocumentDynamicPropertyDto {
        const json = this.toJSON();
        let result = new UpdateDocumentDynamicPropertyDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateDocumentDynamicPropertyDto {
    id: number;
    name: string | undefined;
    type: string | undefined;
    isRequired: boolean;
    isMultiSelect: boolean;
    listItemValues: string[] | undefined;
    regex: string | undefined;
}

export class UpdatePaperworkDto implements IUpdatePaperworkDto {
    id!: number;
    title!: string | undefined;
    state!: Int32EntityDto;
    anomaly!: AnomalyDto;
    note!: string | undefined;
    documentPaperworkTemplateIds!: number[] | undefined;
    parentPaperworkId!: number | undefined;

    constructor(data?: IUpdatePaperworkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.state = _data["state"] ? Int32EntityDto.fromJS(_data["state"]) : undefined as any;
            this.anomaly = _data["anomaly"] ? AnomalyDto.fromJS(_data["anomaly"]) : undefined as any;
            this.note = _data["note"];
            if (Array.isArray(_data["documentPaperworkTemplateIds"])) {
                this.documentPaperworkTemplateIds = [] as any;
                for (let item of _data["documentPaperworkTemplateIds"])
                    this.documentPaperworkTemplateIds!.push(item);
            }
            this.parentPaperworkId = _data["parentPaperworkId"];
        }
    }

    static fromJS(data: any): UpdatePaperworkDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePaperworkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["state"] = this.state ? this.state.toJSON() : undefined as any;
        data["anomaly"] = this.anomaly ? this.anomaly.toJSON() : undefined as any;
        data["note"] = this.note;
        if (Array.isArray(this.documentPaperworkTemplateIds)) {
            data["documentPaperworkTemplateIds"] = [];
            for (let item of this.documentPaperworkTemplateIds)
                data["documentPaperworkTemplateIds"].push(item);
        }
        data["parentPaperworkId"] = this.parentPaperworkId;
        return data;
    }

    clone(): UpdatePaperworkDto {
        const json = this.toJSON();
        let result = new UpdatePaperworkDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePaperworkDto {
    id: number;
    title: string | undefined;
    state: Int32EntityDto;
    anomaly: AnomalyDto;
    note: string | undefined;
    documentPaperworkTemplateIds: number[] | undefined;
    parentPaperworkId: number | undefined;
}

export class UpdatePaperworkTemplateDto implements IUpdatePaperworkTemplateDto {
    id!: number;
    name!: string | undefined;
    paperworkStates!: PaperworkStateDto[] | undefined;
    documentsPaperworkTemplate!: DocumentPaperworkTemplateDto[] | undefined;

    constructor(data?: IUpdatePaperworkTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["paperworkStates"])) {
                this.paperworkStates = [] as any;
                for (let item of _data["paperworkStates"])
                    this.paperworkStates!.push(PaperworkStateDto.fromJS(item));
            }
            if (Array.isArray(_data["documentsPaperworkTemplate"])) {
                this.documentsPaperworkTemplate = [] as any;
                for (let item of _data["documentsPaperworkTemplate"])
                    this.documentsPaperworkTemplate!.push(DocumentPaperworkTemplateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdatePaperworkTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePaperworkTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.paperworkStates)) {
            data["paperworkStates"] = [];
            for (let item of this.paperworkStates)
                data["paperworkStates"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.documentsPaperworkTemplate)) {
            data["documentsPaperworkTemplate"] = [];
            for (let item of this.documentsPaperworkTemplate)
                data["documentsPaperworkTemplate"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): UpdatePaperworkTemplateDto {
        const json = this.toJSON();
        let result = new UpdatePaperworkTemplateDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePaperworkTemplateDto {
    id: number;
    name: string | undefined;
    paperworkStates: PaperworkStateDto[] | undefined;
    documentsPaperworkTemplate: DocumentPaperworkTemplateDto[] | undefined;
}

export class UpdateUserDto implements IUpdateUserDto {
    id!: number;
    name!: string;
    emailAddress!: string;
    isActive!: boolean;
    roleNames!: string[];

    constructor(data?: IUpdateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.roleNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        return data;
    }

    clone(): UpdateUserDto {
        const json = this.toJSON();
        let result = new UpdateUserDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserDto {
    id: number;
    name: string;
    emailAddress: string;
    isActive: boolean;
    roleNames: string[];
}

export class User implements IUser {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    authenticationSource!: string | undefined;
    userName!: string;
    tenantId!: number | undefined;
    emailAddress!: string;
    name!: string;
    surname!: string;
    readonly fullName!: string | undefined;
    password!: string;
    emailConfirmationCode!: string | undefined;
    passwordResetCode!: string | undefined;
    lockoutEndDateUtc!: moment.Moment | undefined;
    accessFailedCount!: number;
    isLockoutEnabled!: boolean;
    phoneNumber!: string | undefined;
    isPhoneNumberConfirmed!: boolean;
    securityStamp!: string | undefined;
    isTwoFactorEnabled!: boolean;
    logins!: UserLogin[] | undefined;
    roles!: UserRole[] | undefined;
    claims!: UserClaim[] | undefined;
    permissions!: UserPermissionSetting[] | undefined;
    settings!: Setting[] | undefined;
    isEmailConfirmed!: boolean;
    isActive!: boolean;
    normalizedUserName!: string;
    normalizedEmailAddress!: string;
    concurrencyStamp!: string | undefined;
    tokens!: UserToken[] | undefined;
    deleterUser!: User;
    creatorUser!: User;
    lastModifierUser!: User;
    assignedCustomers!: AssignedUserCustomer[] | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.authenticationSource = _data["authenticationSource"];
            this.userName = _data["userName"];
            this.tenantId = _data["tenantId"];
            this.emailAddress = _data["emailAddress"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            (this as any).fullName = _data["fullName"];
            this.password = _data["password"];
            this.emailConfirmationCode = _data["emailConfirmationCode"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? moment(_data["lockoutEndDateUtc"].toString()) : undefined as any;
            this.accessFailedCount = _data["accessFailedCount"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.securityStamp = _data["securityStamp"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            if (Array.isArray(_data["logins"])) {
                this.logins = [] as any;
                for (let item of _data["logins"])
                    this.logins!.push(UserLogin.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRole.fromJS(item));
            }
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(UserClaim.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(UserPermissionSetting.fromJS(item));
            }
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings!.push(Setting.fromJS(item));
            }
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.isActive = _data["isActive"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.normalizedEmailAddress = _data["normalizedEmailAddress"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            if (Array.isArray(_data["tokens"])) {
                this.tokens = [] as any;
                for (let item of _data["tokens"])
                    this.tokens!.push(UserToken.fromJS(item));
            }
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : undefined as any;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : undefined as any;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : undefined as any;
            if (Array.isArray(_data["assignedCustomers"])) {
                this.assignedCustomers = [] as any;
                for (let item of _data["assignedCustomers"])
                    this.assignedCustomers!.push(AssignedUserCustomer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["authenticationSource"] = this.authenticationSource;
        data["userName"] = this.userName;
        data["tenantId"] = this.tenantId;
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["password"] = this.password;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        data["passwordResetCode"] = this.passwordResetCode;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : undefined as any;
        data["accessFailedCount"] = this.accessFailedCount;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["securityStamp"] = this.securityStamp;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        if (Array.isArray(this.logins)) {
            data["logins"] = [];
            for (let item of this.logins)
                data["logins"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item ? item.toJSON() : undefined as any);
        }
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["isActive"] = this.isActive;
        data["normalizedUserName"] = this.normalizedUserName;
        data["normalizedEmailAddress"] = this.normalizedEmailAddress;
        data["concurrencyStamp"] = this.concurrencyStamp;
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item ? item.toJSON() : undefined as any);
        }
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : undefined as any;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : undefined as any;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : undefined as any;
        if (Array.isArray(this.assignedCustomers)) {
            data["assignedCustomers"] = [];
            for (let item of this.assignedCustomers)
                data["assignedCustomers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    assignedCustomers: AssignedUserCustomer[] | undefined;
}

export class UserClaim implements IUserClaim {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    tenantId!: number | undefined;
    userId!: number;
    claimType!: string | undefined;
    claimValue!: string | undefined;

    constructor(data?: IUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
        }
    }

    static fromJS(data: any): UserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        return data;
    }

    clone(): UserClaim {
        const json = this.toJSON();
        let result = new UserClaim();
        result.init(json);
        return result;
    }
}

export interface IUserClaim {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
}

export class UserDto implements IUserDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    phoneNumber!: string | undefined;
    emailAddress!: string | undefined;
    roleNames!: string[] | undefined;
    roleDisplayNames!: string[] | undefined;
    isActive!: boolean;
    isDeleted!: boolean;
    lastLoginTime!: moment.Moment | undefined;
    isEmailConfirmed!: boolean;
    fullName!: string | undefined;
    accessFailedCount!: number;
    lockoutEndDateUtc!: moment.Moment | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.phoneNumber = _data["phoneNumber"];
            this.emailAddress = _data["emailAddress"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            if (Array.isArray(_data["roleDisplayNames"])) {
                this.roleDisplayNames = [] as any;
                for (let item of _data["roleDisplayNames"])
                    this.roleDisplayNames!.push(item);
            }
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.lastLoginTime = _data["lastLoginTime"] ? moment(_data["lastLoginTime"].toString()) : undefined as any;
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.fullName = _data["fullName"];
            this.accessFailedCount = _data["accessFailedCount"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? moment(_data["lockoutEndDateUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["phoneNumber"] = this.phoneNumber;
        data["emailAddress"] = this.emailAddress;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        if (Array.isArray(this.roleDisplayNames)) {
            data["roleDisplayNames"] = [];
            for (let item of this.roleDisplayNames)
                data["roleDisplayNames"].push(item);
        }
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : undefined as any;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["fullName"] = this.fullName;
        data["accessFailedCount"] = this.accessFailedCount;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : undefined as any;
        return data;
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    phoneNumber: string | undefined;
    emailAddress: string | undefined;
    roleNames: string[] | undefined;
    roleDisplayNames: string[] | undefined;
    isActive: boolean;
    isDeleted: boolean;
    lastLoginTime: moment.Moment | undefined;
    isEmailConfirmed: boolean;
    fullName: string | undefined;
    accessFailedCount: number;
    lockoutEndDateUtc: moment.Moment | undefined;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
    items!: UserDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserDtoPagedResultDto {
    items: UserDto[] | undefined;
    totalCount: number;
}

export class UserLogin implements IUserLogin {
    id!: number;
    tenantId!: number | undefined;
    userId!: number;
    loginProvider!: string;
    providerKey!: string;

    constructor(data?: IUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.providerKey = _data["providerKey"];
        }
    }

    static fromJS(data: any): UserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        return data;
    }

    clone(): UserLogin {
        const json = this.toJSON();
        let result = new UserLogin();
        result.init(json);
        return result;
    }
}

export interface IUserLogin {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    fullName!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    roleName!: string | undefined;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.fullName = _data["fullName"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["roleName"] = this.roleName;
        return data;
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    fullName: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    roleName: string | undefined;
}

export class UserPermissionSetting implements IUserPermissionSetting {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    tenantId!: number | undefined;
    name!: string;
    isGranted!: boolean;
    userId!: number;

    constructor(data?: IUserPermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isGranted = _data["isGranted"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UserPermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["userId"] = this.userId;
        return data;
    }

    clone(): UserPermissionSetting {
        const json = this.toJSON();
        let result = new UserPermissionSetting();
        result.init(json);
        return result;
    }
}

export interface IUserPermissionSetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    userId: number;
}

export class UserRole implements IUserRole {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    tenantId!: number | undefined;
    userId!: number;
    roleId!: number;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        return data;
    }

    clone(): UserRole {
        const json = this.toJSON();
        let result = new UserRole();
        result.init(json);
        return result;
    }
}

export interface IUserRole {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    roleId: number;
}

export class UserToken implements IUserToken {
    id!: number;
    tenantId!: number | undefined;
    userId!: number;
    loginProvider!: string | undefined;
    name!: string | undefined;
    value!: string | undefined;
    expireDate!: moment.Moment | undefined;

    constructor(data?: IUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserToken {
        data = typeof data === 'object' ? data : {};
        let result = new UserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["value"] = this.value;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : undefined as any;
        return data;
    }

    clone(): UserToken {
        const json = this.toJSON();
        let result = new UserToken();
        result.init(json);
        return result;
    }
}

export interface IUserToken {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;
}

export class WizardInputDto implements IWizardInputDto {
    jobId!: string;
    documentIds!: number[] | undefined;
    paperworkIds!: number[] | undefined;
    concatenationStatus!: boolean;
    includeMetadata!: boolean;
    orderedDocumentIds!: number[] | undefined;
    includeChildPaperworks!: boolean;

    constructor(data?: IWizardInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
            if (Array.isArray(_data["paperworkIds"])) {
                this.paperworkIds = [] as any;
                for (let item of _data["paperworkIds"])
                    this.paperworkIds!.push(item);
            }
            this.concatenationStatus = _data["concatenationStatus"];
            this.includeMetadata = _data["includeMetadata"];
            if (Array.isArray(_data["orderedDocumentIds"])) {
                this.orderedDocumentIds = [] as any;
                for (let item of _data["orderedDocumentIds"])
                    this.orderedDocumentIds!.push(item);
            }
            this.includeChildPaperworks = _data["includeChildPaperworks"];
        }
    }

    static fromJS(data: any): WizardInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new WizardInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        if (Array.isArray(this.paperworkIds)) {
            data["paperworkIds"] = [];
            for (let item of this.paperworkIds)
                data["paperworkIds"].push(item);
        }
        data["concatenationStatus"] = this.concatenationStatus;
        data["includeMetadata"] = this.includeMetadata;
        if (Array.isArray(this.orderedDocumentIds)) {
            data["orderedDocumentIds"] = [];
            for (let item of this.orderedDocumentIds)
                data["orderedDocumentIds"].push(item);
        }
        data["includeChildPaperworks"] = this.includeChildPaperworks;
        return data;
    }

    clone(): WizardInputDto {
        const json = this.toJSON();
        let result = new WizardInputDto();
        result.init(json);
        return result;
    }
}

export interface IWizardInputDto {
    jobId: string;
    documentIds: number[] | undefined;
    paperworkIds: number[] | undefined;
    concatenationStatus: boolean;
    includeMetadata: boolean;
    orderedDocumentIds: number[] | undefined;
    includeChildPaperworks: boolean;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}